<template>
	<div class="ability-page">
		<aside class="side-menu">
			<div class="side-item" :class="{ active: activeSection === 'overview' }" @click="changeSection('overview')">
				<span class="side-icon home-icon"></span>
				<span>能力总览</span>
			</div>
			<div class="side-item" :class="{ active: activeSection === 'industry' }" @click="changeSection('industry')">
				<span class="side-icon mail-icon"></span>
				<span>火锅行业专项能力</span>
			</div>
			<div class="side-item" :class="{ active: activeSection === 'ai' }" @click="changeSection('ai')">
				<span class="side-icon user-icon"></span>
				<span>AI智能能力</span>
			</div>
		</aside>

		<main class="content-area">
			<section v-if="activeSection === 'overview'" class="overview-view">
				<div class="metric-row">
					<div class="metric" :class="{ 'metric-clickable': mIdx === 0 }" v-for="(metric, mIdx) in metrics" :key="metric.title" @click="mIdx === 0 && goComponentOverview()">
						<span class="metric-detail" v-if="mIdx === 0">查看详情</span>
						<div class="metric-title">{{ metric.title }}</div>
						<div class="metric-value" :class="{ 'metric-value-split': metric.subStats }">
							<template v-if="metric.subStats">
								<span v-for="(s, i) in metric.subStats" :key="s.label">{{ s.value }}<i v-if="i < metric.subStats.length - 1"> / </i></span>
							</template>
							<template v-else>{{ metric.value }}</template>
						</div>
						<div class="metric-desc" :class="{ 'metric-desc-split': metric.subStats }">
							<template v-if="metric.subStats">
								<span v-for="(s, i) in metric.subStats" :key="s.label">{{ s.label }}<i v-if="i < metric.subStats.length - 1"> / </i></span>
							</template>
							<template v-else>{{ metric.desc }}</template>
						</div>
					</div>
				</div>
				<div class="chart-grid overview-charts">
					<div class="chart-panel">
						<div class="panel-title">基础技术、行业专项、数据服务、AI能力<br />能力占比</div>
						<div ref="categoryChart" class="chart chart-category"></div>
					</div>
					<div class="chart-panel">
						<div class="panel-head">
							<div class="panel-title">组件调用分析 <span class="chart-unit">单位：万次</span></div>
							<div class="trend-tabs">
								<button :class="{active: trendTab === 'month'}" @click="switchTrendTab('month')">近1月</button>
								<button :class="{active: trendTab === 'year'}" @click="switchTrendTab('year')">近1年</button>
							</div>
						</div>
						<div ref="trendChart" class="chart"></div>
					</div>
				</div>
				<h2 class="section-title">热门能力推荐</h2>
				<div class="recommend-row">
					<div class="recommend" v-for="(item, index) in recommendations" :key="index" @click="openPopup(index)">{{ item.title }}</div>
				</div>
				<h2 class="section-title notice-title">动态消息通知</h2>
				<div class="notice-panel">
					<div class="notice-scroll">
						<div class="notice-item" v-for="(item, i) in notifications" :key="i">
							<span class="notice-type" :class="item.type">{{ item.type }}</span>
							<span class="notice-content">{{ item.content }}</span>
						</div>
						<div class="notice-item" v-for="(item, i) in notifications" :key="'dup-'+i">
							<span class="notice-type" :class="item.type">{{ item.type }}</span>
							<span class="notice-content">{{ item.content }}</span>
						</div>
					</div>
				</div>
			</section>

			<section v-if="activeSection === 'industry'" class="industry-view">
				<div class="industry-hero">
						<div class="hero-head">
							<div class="hero-info">
								<h2 class="hero-title">火锅行业专项能力</h2>
								<p class="hero-desc">贯通一、二、三产的全链路监测、预警与调度</p>
							</div>
							<div class="hero-action-row">
								<button v-for="item in industryActions" :key="item" :class="{active: activeIndustryTab === item}" @click="activeIndustryTab = item">{{ item }}</button>
							</div>
						</div>
						<div class="industry-stats">
							<div class="industry-stat" v-for="metric in activeIndustryMetrics" :key="metric.title">
								<strong>{{ metric.value }}</strong><span>{{ metric.title }}</span>
							</div>
						</div>
					</div>
					<div class="chart-grid risk-grid">
						<div class="chart-panel risk-workbench">
							<div class="panel-head">
								<div class="panel-title">风险预警工单</div>
								<span class="panel-extra">今日新增 9 条 · 待处理 3 条</span>
							</div>
							<div class="risk-list">
								<div class="risk-ticket" v-for="item in riskTickets" :key="item.title" :class="item.level">
									<div class="ticket-info"><b>{{ item.title }}</b><span>{{ item.source }}</span></div>
									<strong>{{ item.status }}</strong>
								</div>
							</div>
						</div>
						<div class="chart-panel project-workbench">
							<div class="panel-head">
								<div class="panel-title">重点项目推进</div>
								<span class="panel-extra">本月更新 12 项</span>
							</div>
							<div class="progress-list">
								<div class="project-progress" v-for="item in projectProgress" :key="item.name">
									<div class="progress-line"><span>{{ item.name }}</span><b>{{ item.percent }}%</b></div>
									<div class="progress-track"><i :style="{ width: item.percent + '%' }"></i></div>
								</div>
							</div>
						</div>
					</div>
				<div class="industry-capabilities">
					<div class="industry-column function-card" v-for="column in industryColumns" :key="column.title" @click="openIndustryPopup(column.title)">
						<h2>{{ column.title }}</h2>
						<div class="column-body">
							<div class="function-main"><strong>{{ column.value }}</strong><span>{{ column.unit }}</span></div>
							<p v-for="line in column.lines" :key="line">{{ line }}</p>
							<!-- <button>{{ column.action }}</button> -->
						</div>
					</div>
				</div>
			</section>

			<section v-if="activeSection === 'ai'" class="ai-view">
				<div class="ai-toolbar"><label>食材 <select v-model="pepper">
							<option v-for="item in aiOptions.ingredients" :key="item.code" :value="item.code">{{ item.name }}</option>
						</select></label><label>地区 <select v-model="city">
							<option v-for="item in aiOptions.regions" :key="item.code" :value="item.code">{{ item.name }}</option>
						</select></label><label>基地 <select v-model="base">
							<option v-for="item in filteredBases" :key="item.code" :value="item.code">{{ item.name }}</option>
						</select></label></div>
				<div class="ai-grid" style="margin-top: 20px;">
				<div class="ai-block">
					<h2>AI行情分析</h2>
					<div class="chart-panel ai-panel">
						<div class="tabs"><button v-for="tab in analysisTabs" :key="tab"
								:class="{ selected: analysisTab === tab }"
								@click="analysisTab = tab">{{ tab }}</button></div>
						<div v-if="analysisTab === '价格趋势预测'" ref="marketChart" class="chart market-chart"></div>
						<div v-else-if="analysisTab === '季节性波动分析'" class="season-panel">
							<div class="season-item" v-for="item in seasonalAnalysis" :key="item.period">
								<div class="season-period">{{ item.period }}</div>
								<p>{{ item.text }}</p>
							</div>
						</div>
						<div v-else class="news-list">
							<div class="news-item" v-for="report in marketReports" :key="report.id"
								@click="openNews(report)">
								<span class="news-tag" :class="report.tagType">{{ report.tag }}</span>
								<div class="news-item-body">
									<div class="news-title">{{ report.title }}</div>
									<div class="news-meta">{{ report.date }} · {{ report.source }}</div>
								</div>
								<span class="news-arrow">详情</span>
							</div>
						</div>
					</div>
				</div>
				<div class="ai-block">
					<h2>AI需求预测</h2>
					<div class="chart-panel ai-panel">
						<div class="tabs"><button v-for="tab in demandTabs" :key="tab"
								:class="{ selected: demandTab === tab }" @click="demandTab = tab">{{ tab }}</button>
						</div>
						<div ref="demandChart" class="chart demand-chart"></div>
					</div>
				</div>
			</div>
			<div class="ai-grid bottom-ai" style="margin-top: 10px;">
				<div class="ai-block">
					<h2>AI风险预警</h2>
					<div class="chart-panel ai-panel">
						<div class="tabs"><button v-for="tab in riskTabs" :key="tab"
								:class="{ selected: riskTab === tab }" @click="riskTab = tab">{{ tab }}</button></div>
						<div v-if="riskTab === '供应链断供'" class="risk-visual">
							<div ref="riskChart" class="risk-chart"></div>
							<div class="risk-message">预警：某供应商延迟交付风险提升至75%</div>
						</div>
						<div v-else class="news-list">
							<div class="news-item" v-for="news in riskNews[riskTab]" :key="news.id"
								@click="openNews(news)">
								<span class="news-tag" :class="news.tagType">{{ news.level }}</span>
								<div class="news-item-body">
									<div class="news-title">{{ news.title }}</div>
									<div class="news-meta">{{ news.date }} · {{ news.source }}</div>
								</div>
								<span class="news-arrow">详情</span>
							</div>
						</div>
					</div>
				</div>
				<div class="ai-block">
					<h2>AI内容生成</h2>
					<div class="chart-panel ai-panel content-copy">
						<div class="tabs"><button v-for="tab in contentTabs" :key="tab"
								:class="{ selected: contentTab === tab }"
								@click="contentTab = tab">{{ tab }}</button></div>
						<div class="news-list">
							<div class="news-item" v-for="news in contentNews[contentTab]" :key="news.id"
								@click="openNews(news)">
								<div class="news-item-body">
									<div class="news-title">{{ news.title }}</div>
									<div class="news-summary">{{ news.summary }}</div>
									<div class="news-meta">{{ news.date }} · {{ news.source }}</div>
								</div>
								<span class="news-arrow">阅读</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		</main>

		<div class="popup-mask" v-if="activePopupIndex !== null" @click="closePopup()"></div>
		<div class="ability-popup" v-if="activePopupIndex !== null">
			<div class="popup-close" @click="closePopup()">&times;</div>
			<div class="popup-title">{{ recommendationDetails[activePopupIndex].title }}</div>
			<div class="popup-card-row">
				<div class="popup-stat-card" v-for="stat in recommendationDetails[activePopupIndex].stats" :key="stat.label">
					<div class="popup-stat-num">{{ stat.num }}</div>
					<div class="popup-stat-label">{{ stat.label }}</div>
				</div>
			</div>
			<div class="popup-chart-wrap">
				<div class="popup-chart-box">
					<div class="popup-chart-label">{{ recommendationDetails[activePopupIndex].charts[0] }}</div>
					<div ref="popupChart1" class="popup-chart"></div>
				</div>
				<div class="popup-chart-box">
					<div class="popup-chart-label">{{ recommendationDetails[activePopupIndex].charts[1] }}</div>
					<div v-if="!popupHasRanking" ref="popupChart2" class="popup-chart"></div>
					<div v-else class="popup-price-panel">
						<div class="price-item" v-for="item in popupRankingData" :key="item.name">
							<span class="price-name">{{ item.name }}</span>
							<span class="price-change" :class="item.change >= 0 ? 'up' : 'down'">{{ formatRankChange(item) }}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="popup-desc">{{ recommendationDetails[activePopupIndex].desc }}</div>
	</div>

	<div class="popup-mask" v-if="newsDetail" @click="closeNews()"></div>
		<div class="news-popup" v-if="newsDetail">
			<div class="popup-close" @click="closeNews()">&times;</div>
			<div class="news-popup-title">{{ newsDetail.title }}</div>
			<div class="news-popup-meta">
				<span>{{ newsDetail.date }}</span>
				<span>{{ newsDetail.source }}</span>
				<span v-if="newsDetail.level" class="news-tag" :class="newsDetail.tagType">{{ newsDetail.level }}</span>
			</div>
			<div class="news-popup-body">
				<p v-for="(para, i) in newsDetail.content" :key="i">{{ para }}</p>
			</div>
		</div>

		<div class="popup-mask" v-if="activeIndustryPopup" @click="activeIndustryPopup = null"></div>
		<div class="industry-popup" v-if="activeIndustryPopup">
			<div class="popup-close" @click="activeIndustryPopup = null">&times;</div>
			<div class="industry-popup-title">{{ activeIndustryPopup }}能力</div>
			<div class="industry-popup-sub">{{ industryPopupSubtitle }}</div>
			<ol class="industry-popup-list">
				<li v-for="(item, i) in industryPopupData" :key="i">
					<div class="cap-name">{{ item.name }}</div>
					<div class="cap-desc">{{ item.desc }}</div>
				</li>
			</ol>
		</div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'

	export default {
		name: 'AbilityCenter',
		data() {
			return {
				highlightTimers: [],
				activeSection: 'overview',
				pepper: 'chili',
				city: 'chongqing',
				base: '',
				aiOptions: { ingredients: [], regions: [], bases: [] },
				aiChartData: { price: null, sales: null, capacity: null, purchase: null, 'supply-risk': null },
				analysisTab: '价格趋势预测',
				demandTab: '历史销量',
				riskTab: '供应链断供',
				contentTab: '产业资讯',
				newsDetail: null,
				riskTabs: ['供应链断供', '食品安全', '市场价格异动'],
				contentTabs: ['产业资讯', '政策解读', '分析简报'],
				newsCategoryMap: {
					'行情早报': 'market-report',
					'食品安全': 'food-safety',
					'市场价格异动': 'price-alert',
					'产业资讯': 'industry-news',
					'政策解读': 'policy',
					'分析简报': 'analysis-brief'
				},
				// 季节性波动解说：依据全国辣椒主产季分布整理
				seasonalAnalysis: [
					{
						period: '冬春保障期（12月—次年4月）',
						text: '全国辣椒供应以海南、广东、云南等南方冬春椒"南菜北运"为主，供应量约占全年15%。此时正值火锅消费旺季，需求旺盛而供给偏紧，价格维持年内高位，建议加工与餐饮企业提前锁价、错峰备货。'
					},
					{
						period: '春夏衔接期（5—6月）',
						text: '南方冬春椒进入尾期，西南产区早熟鲜椒（螺丝椒、线椒等）6月起陆续上市。市场处于"青黄不接"向新椒供应过渡阶段，批发价通常在3—5月见顶，6月后随新椒上量开始回落。'
					},
					{
						period: '夏秋集中上市期（7—10月）',
						text: '贵州、四川、重庆等西南主产区辣椒7月中旬起集中红熟，河南、新疆、内蒙古等北方干辣椒8月底陆续开采、10—11月进入烘干高峰，10月达到全年供应峰值。新椒集中上量推动价格降至年内低点，是干辣椒收储和底料加工的最佳窗口期。'
					},
					{
						period: '秋冬收尾期（11月）',
						text: '北方产区采收烘干基本结束，全国供应量快速回落，价格触底回升；海南、云南等南方冬春椒开始移栽定植，为次年冬春供应做准备，火锅企业可关注新季干椒收储成本与库存节奏。'
					}
				],
				// 行情早报（数据由行情库推送，此处为库内最新测报）
				marketReports: [
					{
						id: 'mr1', date: '2026-10-13', tag: '稳中偏弱', tagType: 'tag-down',
						source: '中国辣椒城·遵义虾子镇',
						title: '遵义朝天椒新椒集中上市 干椒价格稳中偏弱',
						content: [
							'据中国辣椒城（遵义虾子镇）10月13日测报，本地朝天椒新椒进入集中上市期，市场日均到货量较上周增加约18%，经销商按需补库，干椒成交价格稳中偏弱。',
							'目前满天星新椒好货成交价约13.2—14.0元/斤，较上周回落0.3元/斤左右；子弹头、灯笼椒走势平稳。中国辣椒城日均辣椒交易量保持在600吨以上，发运方向以川渝、华南加工企业为主。',
							'测报建议：短期新椒上量仍将压制干椒价格，火锅底料企业可分批逢低建立秋冬季库存。'
						]
					},
					{
						id: 'mr2', date: '2026-10-12', tag: '供应稳定', tagType: 'tag-flat',
						source: '河南内黄辣椒产区测报站',
						title: '河南内黄新一代辣椒进入采收尾期 上货量保持稳定',
						content: [
							'河南安阳内黄产区10月12日测报：当地13万亩新一代辣椒已进入采收尾期，鲜椒亩均产量约2500斤、折干椒600斤以上，烘干线开工率维持高位。',
							'当前新一代干椒产地成交价约11.8—12.5元/斤，与上周基本持平；尾期货源以色度好、水分低的优质干椒为主，受到色素提取与底料加工企业青睐。',
							'产区预计本月下旬新干椒上货将基本结束，后续价格或随货源收紧小幅回升。'
						]
					},
					{
						id: 'mr3', date: '2026-10-11', tag: '环比上涨', tagType: 'tag-up',
						source: '重庆双福国际农贸城测报点',
						title: '江津青花椒进入产季尾期 好货价格环比上涨6%',
						content: [
							'重庆双福国际农贸城10月11日测报：江津青花椒秋椒交易进入尾期，市场优质货源减少，好货批发价较10月初环比上涨约6%。',
							'当前九叶青干花椒一等货报价约58—62元/斤，普通货48—52元/斤。麻香味浓郁、开口率高的优质货走货最快，火锅及花椒油加工企业采购积极性较高。',
							'测报提示：尾期行情偏强，建议用椒大户锁定11月前的刚需用量，同时关注陕西、甘肃等地产区的替代货源。'
						]
					},
					{
						id: 'mr4', date: '2026-10-10', tag: '价格坚挺', tagType: 'tag-up',
						source: '新疆产区联合测报站',
						title: '新疆色素椒烘干进度过半 走货顺畅价格坚挺',
						content: [
							'新疆巴州、昌吉产区10月10日联合测报：板椒、色素椒机械化采收与烘干进度已过半，今年单产与色价表现良好，辣椒红素加工企业订单充足。',
							'产区色素鲜椒收购价约1.6—1.9元/公斤，优质板椒干椒报价13元/斤上下，较开秤初期上涨约4%，走货顺畅。',
							'若10月下旬出现提前降温天气，烘干成本与采收节奏将受到影响，需警惕色素椒价格进一步上行向火锅底料企业传导。'
						]
					},
					{
						id: 'mr5', date: '2026-10-09', tag: '需求回暖', tagType: 'tag-flat',
						source: '川渝火锅产业链监测',
						title: '国庆后火锅消费回暖 底料企业补库需求增加',
						content: [
							'川渝火锅产业链监测数据显示，国庆长假后终端火锅门店客流环比回升，连锁品牌门店平均翻台率恢复至节前水平，家庭火锅外卖订单保持稳健增长。',
							'底料加工企业近两周干辣椒、牛油、花椒等原料补库需求明显增加，10月上旬主要原料采购量环比增长约12%。',
							'随着秋冬季消费旺季到来，预计10月下旬至11月原料端整体需求将继续走强。'
						]
					},
					{
						id: 'mr6', date: '2026-10-08', tag: '以稳为主', tagType: 'tag-down',
						source: '成都国际铁路港冷链测报点',
						title: '重庆市场牛油库存充足 短期价格以稳为主',
						content: [
						 '成都、重庆两地农贸城10月8日测报：火锅牛油现货库存处于近三年同期较高水平，进口及国产牛油到港到库节奏正常，供应保障充足。',
							'当前精炼牛油批发价约12.8元/公斤，较9月下旬下跌约2.1%，毛肚、黄喉等冻品价格暂未出现明显波动。',
							'测报判断：在无极端天气与进口政策变化的前提下，10月份牛油价格大概率以稳为主，小幅偏弱运行。'
						]
					}
				],
				// AI风险预警新闻库（按预警类型分库）
				riskNews: {
					'食品安全': [
						{
							id: 'fs1', date: '2026-10-12', level: '红色预警', tagType: 'tag-red',
							source: '食品安全风险监测',
							title: '成都某火锅连锁底料检出工业染料 涉事批次已查封',
							content: [
								'风险监测系统10月12日抓取到监管通报：成都某火锅连锁企业中央工厂生产的一批次火锅底料检出非食用物质罗丹明B，当地市场监管部门已查封涉事批次产品并立案调查。',
								'平台已对该企业供应链关联的23家在营门店发出红色风险提示，建议接入平台的餐饮主体立即核查同品牌、同批次底料的采购与使用记录。',
								'处置建议：立即暂停相关产品采购，留存进货票据与检验报告，等待监管部门复检结果。'
							]
						},
						{
							id: 'fs2', date: '2026-10-11', level: '黄色预警', tagType: 'tag-yellow',
							source: '市场监管抽检',
							title: '盘溪市场毛肚抽检菌落总数超标 3批次产品已召回',
							content: [
								'重庆江北区市场监管局10月11日发布抽检通告：盘溪农副产品市场3批次水发毛肚菌落总数超标，涉及2家经销商，问题产品已启动召回。',
								'抽检同时发现个别商户冷链记录不完整，水发产品浸泡液温度超出管控要求。',
								'平台建议采购企业优先选择具备全程冷链与溯源二维码的供应商，到货后严格查验检验检疫证明。'
							]
						},
						{
							id: 'fs3', date: '2026-10-09', level: '黄色预警', tagType: 'tag-yellow',
							source: '农业质量监管',
							title: '遵义一批次干辣椒二氧化硫残留超标 已立案调查',
							content: [
								'农业质量监管线索显示，遵义某产地经销商一批次干辣椒二氧化硫残留量超出标准限量，疑似存在违规熏蒸护色行为，涉案产品约2.6吨，已被就地封存。',
								'平台风险模型提示：新椒集中上市期是违规熏蒸高发期，采购干椒时应重点关注批次检测报告中的二氧化硫、罗丹明B指标。',
								'已接入标准核验库的企业可通过批次比对功能一键排查近30天同类货源。'
							]
						},
						{
							id: 'fs4', date: '2026-10-07', level: '蓝色提醒', tagType: 'tag-blue',
							source: '重庆市市场监管局',
							title: '秋季火锅食材专项抽检通告发布 总体合格率98.6%',
							content: [
								'重庆市市场监管局10月7日发布秋季火锅食材专项抽检通告，共抽检底料、毛肚、黄喉、鸭血、干辣椒等食材1120批次，总体合格率98.6%。',
								'不合格项目主要集中在水发产品微生物指标与蔬菜制品农残，未发现系统性、区域性食品安全风险。',
								'平台已同步更新供应商风险画像，建议餐饮主体关注抽检通告中的产地与品牌信息，动态调整采购白名单。'
							]
						}
					],
					'市场价格异动': [
						{
							id: 'mp1', date: '2026-10-13', level: '红色预警', tagType: 'tag-red',
							source: '价格异动监测',
							title: '新疆板椒受强降温天气影响 收购价周环比上涨8.3%',
							content: [
								'价格异动监测显示，受10月上旬新疆巴州、昌吉产区强降温天气影响，色素板椒采收与烘干节奏放缓，新干椒收购价一周内环比上涨8.3%。',
								'当前新疆板椒干椒报价已升至13.5元/斤附近，若低温天气持续，10月下旬价格仍有上行空间。',
								'平台建议：以板椒为主要原料的底料企业可加快备货节奏，并关注河南、内蒙古产区替代货源的比价机会。'
							]
						},
						{
							id: 'mp2', date: '2026-10-12', level: '黄色预警', tagType: 'tag-yellow',
							source: '价格异动监测',
							title: '江津青花椒进入产季尾期 价格两周累计上涨12%',
							content: [
								'江津青花椒产季进入尾期，优质货源收紧，九叶青干花椒好货价格近两周累计上涨约12%，当前报价58—62元/斤。',
								'模型研判：尾期优质优价特征明显，11月后新货断档，价格大概率维持高位运行至明年春椒上市前。',
								'建议火锅与花椒油加工企业按冬季用量提前锁定货源，必要时通过平台供需撮合功能对接陕西、甘肃产区。'
							]
						},
						{
							id: 'mp3', date: '2026-10-10', level: '黄色预警', tagType: 'tag-yellow',
							source: '冷链行情监测',
							title: '进口毛肚到港延迟 川渝批发市场价格上涨6.5%',
							content: [
								'受国际船期调整影响，近期进口毛肚到港量减少，成都、重庆批发市场毛肚均价较9月下旬上涨6.5%，部分大叶片规格缺货。',
								'平台供需监测显示，川渝地区毛肚日均需求保持稳定，供应缺口短期难以完全弥补。',
								'建议餐饮企业适当增加国产水发毛肚与牛杂类替代品的采购比例，并关注10月下旬船期恢复情况。'
							]
						},
						{
							id: 'mp4', date: '2026-10-08', level: '价格下行', tagType: 'tag-green',
							source: '价格异动监测',
							title: '牛油现货供应充足 川渝市场价格环比下跌2.1%',
							content: [
								'川渝两地精炼牛油库存处于近年同期高位，供应充足，批发价环比下跌2.1%，当前报价约12.8元/公斤。',
								'模型研判：在进口到港正常、终端需求平稳的情况下，10月份牛油价格将以稳中有弱为主。',
								'底料企业可结合秋冬季排产计划，在当前价格区间分批建库，降低原料综合成本。'
							]
						}
					]
				},
				// AI内容生成新闻资料库（对接内容库后由接口返回，现按分类内置）
				contentNews: {
					'产业资讯': [
						{
							id: 'c1', date: '2026-10-11', source: '央视财经',
							title: '贵州辣椒全产业链产值突破288亿元 产量连续多年稳居全国第一',
							summary: '贵州以504万亩种植规模、729万吨年产量连续多年稳居全国首位，300多家加工企业产品远销140多个国家和地区。',
							content: [
								'据央视财经10月11日报道，贵州辣椒全产业链年产值已突破288亿元。目前贵州辣椒种植面积504万亩、年产量729万吨，连续多年稳居全国第一，带动超过140万椒农户均年增收1.8万元。',
								'在遵义虾子镇的中国辣椒城，每天有超过600吨辣椒经3000多名经纪人发往全国，年交易量达35万吨，已成为全国辣椒价格的风向标。',
								'全省现有300多家辣椒加工企业，开发出9大系列70多类产品，远销140多个国家和地区，加工产值达180亿元，居全国第一，其中贵州油辣椒占据国内市场约70%的份额。'
							]
						},
						{
							id: 'c2', date: '2026-10-09', source: '人民网·贵州频道',
							title: '中国辣椒城年交易量达35万吨 成为全国辣椒价格风向标',
							summary: '虾子镇中国辣椒城汇聚全国各产区货源，日交易量超600吨，价格指数对全国干辣椒定价具有重要参考意义。',
							content: [
								'遵义虾子镇中国辣椒城是目前全国规模最大的干辣椒专业交易市场之一，汇聚了贵州、河南、新疆、内蒙古、云南等全国主产区的货源。',
								'市场日均交易量超过600吨，年交易量达35万吨，围绕市场活跃着3000多名辣椒经纪人，发布的辣椒价格指数已成为全国干辣椒贸易的重要定价参考。',
								'随着冷链物流与电子交易平台的完善，中国辣椒城的价格发现与供需撮合功能正进一步向火锅产业链上下游延伸。'
							]
						},
						{
							id: 'c3', date: '2026-10-06', source: '中国饭店协会',
							title: '家庭火锅外卖订单年增35% 露营火锅等跨界场景受年轻人追捧',
							summary: '《2026中国火锅产业消费报告》显示，家庭场景火锅外卖保持高速增长，露营、剧本杀等跨界火锅玩法快速兴起。',
							content: [
								'中国饭店协会近期发布的报告显示，家庭火锅外卖订单量同比增长35%，一人食小火锅、半成品火锅套餐增速领先。',
								'消费场景方面，露营火锅、景区火锅、剧本杀+火锅等跨界玩法受到年轻消费者追捧，带动火锅食材零售化、标准化包装需求上升。',
								'健康化趋势同样明显，低脂汤底、植物蛋白食材、减盐底料的关注度持续提升，为产业链产品创新提供了新方向。'
							]
						},
						{
							id: 'c4', date: '2026-10-04', source: '餐饮行业观察',
							title: '川渝麻辣火锅仍占市场主导 粤式打边炉与潮汕牛肉锅增速最快',
							summary: '全国火锅门店数据监测显示，川渝麻辣火锅门店占比保持第一，粤式、潮汕等清淡品类在下沉市场增速亮眼。',
							content: [
								'全国火锅门店监测数据显示，川渝麻辣火锅门店数量仍占市场主导地位，品牌化、连锁化程度最高。',
								'从增速看，粤式打边炉、潮汕牛肉锅、椰子鸡等清淡口味品类在新一线城市及下沉市场扩张最快，门店数同比增长均超过20%。',
								'区域口味多元化对食材供应链提出了更高要求，鲜切牛肉、海鲜丸子、特色蘸料等细分品类的撮合需求明显增加。'
							]
						}
					],
					'政策解读': [
						{
							id: 'p1', date: '2026-10-10', source: '政策解读',
							title: '《火锅食材冷链物流操作规范》行业标准公开征求意见',
							summary: '新标准对水发产品、冻品、鲜切食材的运输温度、交接记录与溯源信息提出统一要求，预计年底前发布。',
							content: [
								'近日，《火锅食材冷链物流操作规范》行业标准面向社会公开征求意见。标准对毛肚、黄喉、鸭血等水发与冷冻食材的运输温度、装卸时限、温度记录频率作出统一规定。',
								'标准要求冷链交接全过程留存温度与责任人记录，并与食材溯源信息关联，平台经营主体需在标准实施后完成冷链数据接口改造。',
								'解读认为，该标准将显著提升火锅食材流通环节的食品安全水平，也为平台冷链异常智能预警提供了统一的数据口径。'
							]
						},
						{
							id: 'p2', date: '2026-10-07', source: '政策解读',
							title: '多部门部署秋冬季食品安全专项抽检 辣椒制品列入重点品种',
							summary: '市场监管总局等三部门联合部署秋冬季食品安全专项行动，辣椒制品、火锅底料、水发产品被列为重点抽检对象。',
							content: [
								'市场监管总局等三部门联合印发通知，部署秋冬季食品安全专项抽检与隐患排查行动，时间覆盖10月至次年2月火锅消费旺季。',
								'辣椒制品、火锅底料、水发产品、冷链肉类等被列为重点品种，严查二氧化硫残留、非法添加、微生物超标等问题。',
								'平台将同步更新食品安全预警规则，建议供应商提前开展自检，餐饮企业通过标准核验模块留存完整进货台账。'
							]
						},
						{
							id: 'p3', date: '2026-10-03', source: '政策解读',
							title: '重庆出台火锅产业高质量发展行动计划 2028年产业规模目标超3000亿元',
							summary: '行动计划提出建设全国火锅食材交易与价格中心，推动产业链数字化协同，培育一批百亿级龙头企业。',
							content: [
								'重庆市近日发布火锅产业高质量发展行动计划，提出到2028年全市火锅产业全产业链规模超过3000亿元的发展目标。',
								'计划明确建设全国火锅食材交易中心与价格发布中心，推动辣椒、花椒、牛油等核心原料的数字化供需撮合与价格指数应用。',
								'在产业组织方面，将培育一批百亿级龙头企业与专精特新供应链企业，并对接入数字化溯源与标准核验体系的主体给予政策支持。'
							]
						}
					],
					'分析简报': [
						{
							id: 'a1', date: '2026-10-12', source: 'AI分析简报',
							title: '四季度辣椒行情研判：新椒上量价格承压 冬至后有望企稳回升',
							summary: '模型综合产区天气、库存与季节性需求研判，10月干椒价格仍有下行空间，11月后随货源收紧逐步企稳。',
							content: [
								'AI模型结合全国主产区采收进度、中国辣椒城库存、天气预测与终端采购数据，对四季度辣椒行情作出研判。',
								'10月西南与北方新椒集中上市，供应充足，干椒价格整体承压偏弱；11月北方采收结束后货源收紧，叠加火锅旺季需求，价格有望企稳回升。',
								'风险提示：若新疆、河南产区出现持续低温或降雨天气，烘干成本上升可能提前推动价格反弹，建议用椒企业10月内完成主要备货。'
							]
						},
						{
							id: 'a2', date: '2026-10-08', source: 'AI分析简报',
							title: '火锅底料原料成本月度监测：牛油同比下跌 花椒价格偏强运行',
							summary: '9月底料综合原料成本环比基本持平，其中牛油同比下跌约6%，青花椒受尾期影响价格偏强，干辣椒处年内低位。',
							content: [
								'平台对构成火锅底料主要成本的干辣椒、牛油、花椒、豆瓣酱等原料进行月度监测。',
								'9月综合原料成本环比基本持平、同比下降约3%：牛油供应充足，价格同比下跌约6%；干辣椒处新椒上市年内低位；青花椒受产季尾期影响价格偏强运行。',
								'简报建议底料企业把握干辣椒与牛油的低价窗口分批建库，对花椒采取"刚需现采+远月锁价"相结合的采购策略。'
							]
						},
						{
							id: 'a3', date: '2026-10-05', source: 'AI分析简报',
							title: '全国火锅门店景气指数报告：9月新开门店环比增长4.2%',
							summary: '9月全国火锅门店景气指数环比回升，川渝门店密度保持第一，下沉市场新店占比首次超过五成。',
							content: [
								'全国火锅门店景气指数监测报告显示，9月行业景气指数环比回升，新开门店数量环比增长4.2%，闭店率较夏季旺季前有所下降。',
								'区域方面，川渝地区门店密度继续保持全国第一；三线及以下城市新店占比首次超过50%，下沉市场成为品牌扩张主战场。',
								'模型预测四季度受火锅消费旺季带动，食材采购需求将环比增长8%—12%，建议供应链企业提前调配冷链与仓储产能。'
							]
						}
					]
				},
				trendTab: 'month',
				trendApiData: { month: null, year: null },
				metrics: [{
					title: '开放能力组件',
					subStats: [{ value: '12', label: '总数' }, { value: '12', label: '在用' }, { value: '0', label: '待上线' }]
				}, {
					title: '累计授权企业数',
					value: '1750',
					desc: '家'
				}, {
					title: '活跃企业数',
					value: '1733',
					desc: '家'
				}, {
					title: '接口日均调用量',
					value: '12.6万',
					desc: '次/天'
				}, {
					title: '调用成功率',
					value: '99.7%',
					desc: ''
				}, {
					title: '系统运行状态',
					value: '正常',
					desc: ''
				}],
				notifications: [{
					type: '组件更新',
					content: '食材溯源组件 v2.3 已发布，新增批次扫码核验接口'
				}, {
					type: '接口维护',
					content: '供需匹配接口将于今晚 23:00-24:00 维护升级'
				}, {
					type: '权限申请',
					content: '重庆德庄火锅连锁申请接入价格行情分析接口'
				}, {
					type: '安全预警',
					content: '检测到异常高频调用，已对 XX 企业触发限流'
				}, {
					type: '组件更新',
					content: '食品安全预警组件新增舆情风险监测能力'
				}, {
					type: '接口维护',
					content: '价格行情分析接口数据源扩容完成，延迟降低 40%'
				}],
				recommendations: [
					{ code: 'trace', title: '食材溯源' },
					{ code: 'match', title: '供需匹配' },
					{ code: 'safety', title: '食品安全预警' },
					{ code: 'price', title: '价格行情分析' }
				],
				ratios: [],
				activePopupIndex: null,
				activeIndustryPopup: null,
				industryCapabilities: {
					'一产种养监测': {
						subtitle: '一产 | 种养原料端',
						items: [
							{ name: '基地台账管理能力', desc: '建立基地主体档案、面积、品种、农户台账，实现基地身份化、数字化管理。' },
							{ name: '种养环境监测能力', desc: '接入土壤墒情、气象、水质等传感器，实时监测基地生长环境并预警异常。' },
							{ name: '原料产量预估能力', desc: '基于长势、面积、气象数据预估辣椒、花椒等原料产量，辅助产季调度。' },
							{ name: '产地价格监控能力', desc: '采集主产区产地批发价，形成价格曲线与波动预警，支撑行情研判。' },
							{ name: '农残合规核验能力', desc: '对采收批次进行农残快检与合规判定，拦截不合格原料流入下游。' },
							{ name: '原料批次溯源能力', desc: '绑定采收批次信息向下游流转，实现从基地到工厂的全链路溯源。' },
							{ name: '产地风险工单能力', desc: '对灾害、价格、质量异常生成风险工单，闭环跟踪预警-派单-整改-复核。' },
							{ name: '产地供需撮合能力', desc: '汇集基地供应与加工需求，撮合订单与物流，降低产销错配。' },
							{ name: '示范基地项目调度能力', desc: '管理示范基地建设进度、资金、验收，实现项目全过程调度。' },
							{ name: '地理标志管控能力', desc: '对江津花椒、石柱红辣椒等地标产品进行授权使用与防伪溯源管理。' }
						]
					},
					'二产加工监管': {
						subtitle: '二产 | 加工制造端（底料、食材加工厂）',
						items: [
							{ name: '加工企业台账能力', desc: '管理底料、食材加工企业主体档案、产能、产品，形成统一企业画像。' },
							{ name: '生产过程监测能力', desc: '接入关键工序温度、时间、投料数据，监控生产合规性与工艺执行。' },
							{ name: '产品标准核验能力', desc: '比对重庆火锅底料地方标准，核验配方与理化指标符合性。' },
							{ name: '证照到期预警能力', desc: '监控 SC 生产许可、排污许可等到期时间，提前预警续证。' },
							{ name: '出厂抽检研判能力', desc: '汇总出厂抽检结果，研判质量趋势与风险点，驱动持续改进。' },
							{ name: '上下游链路分析能力', desc: '分析加工企业原料来源与产品流向，识别断供与集中度风险。' },
							{ name: '加工风险工单能力', desc: '对生产异常、抽检不合格等生成工单，闭环处置并归档。' },
							{ name: '工厂供需撮合能力', desc: '匹配加工产能与下游门店订单，提升产线利用率与履约效率。' }
						]
					},
					'三产门店运营': {
						subtitle: '三产 | 门店运营端（火锅门店、餐饮零售）',
						items: [
							{ name: '门店经营台账能力', desc: '管理门店主体、位置、品类、经营数据，形成门店统一档案。' },
							{ name: '门店合规检查能力', desc: '汇总食安、消防、用工检查记录与整改情况，跟踪合规状态。' },
							{ name: '门店采购溯源能力', desc: '追溯门店食材来源，匹配上游供应批次，实现终端可追溯。' },
							{ name: '区域饱和度分析能力', desc: '评估各区域门店密度、同业竞争与饱和度，辅助选址决策。' },
							{ name: '消费热力分析能力', desc: '基于客流与消费数据生成消费热力图，洞察消费趋势。' },
							{ name: '门店风险预警能力', desc: '对差评、投诉、抽检异常生成预警与工单，闭环处置。' },
							{ name: '门店供需撮合能力', desc: '匹配门店采购需求与集配中心供应，降低采购成本。' },
							{ name: '连锁化运营能力', desc: '支持连锁门店标准化、统一采购与品牌管控，赋能连锁扩张。' }
						]
					},
					'配套服务调度': {
						subtitle: '配套 | 物流、金融、人才、质检服务调度',
						items: [
							{ name: '物流冷链调度能力', desc: '管理冷链仓配资源，调度配送路径与温控监测，保障履约。' },
							{ name: '金融服务撮合能力', desc: '对接供应链金融产品，管理企业授信与融资，缓解资金压力。' },
							{ name: '人才服务调度能力', desc: '汇集厨师、采购、运营人才需求与供给，撮合就业匹配。' },
							{ name: '质检溯源协同能力', desc: '协调第三方质检机构，对接抽检任务与溯源链路，提升合规效率。' },
							{ name: '企业信用画像能力', desc: '基于多维数据形成企业信用评分与画像，支撑融资与撮合。' },
							{ name: '冷链仓配协同能力', desc: '协同冷库、车队、集配中心资源调度，提升冷链整体效率。' },
							{ name: '抽检溯源协同能力', desc: '协同监管部门抽检任务与溯源链路，实现监管与业务联动。' },
							{ name: '综合服务工单能力', desc: '对各类服务请求生成工单闭环跟踪，确保服务质量与响应。' }
						]
					}
				},
				recommendationDetails: [{
					title: '食材溯源｜能力详情',
					stats: [
						{ num: '628', label: '溯源覆盖企业（家）' },
						{ num: '21460', label: '溯源批次总量（批）' },
						{ num: '4.2万', label: '日溯源查询调用' },
						{ num: '99.2%', label: '扫码核验通过率' }
					],
					charts: ['柱状图：核心食材溯源批次统计', '地理点位图：全国食材产地分布'],
					desc: '实现辣椒、花椒、牛油、生鲜毛肚、火锅底料等核心原料，从产地、加工、流通到餐饮门店全链路溯源。支持批次查询、溯源码扫码核验，实现来源可查、去向可追，保障火锅食材质量安全。'
				}, {
					title: '供需匹配｜能力详情',
					stats: [
						{ num: '472', label: '入驻供应企业（家）' },
						{ num: '816', label: '入驻需求企业（家）' },
						{ num: '1368', label: '累计撮合交易（笔）' },
						{ num: '7.8万', label: '月供需对接访问量' }
					],
					charts: ['折线图：近6个月撮合成功笔数趋势', '饼图：供需品类占比'],
					desc: '打通上游种植加工企业、中游底料生产厂、下游火锅餐饮门店，基于企业需求标签智能匹配货源，减少中间流通环节，降低产业链采购成本，助力火锅产业供应链高效协同。'
				}, {
					title: '食品安全预警｜能力详情',
					stats: [
						{ num: '941', label: '监测接入主体（家）' },
						{ num: '327', label: '累计预警事件（条）' },
						{ num: '312', label: '已闭环处置预警（条）' },
						{ num: '95.4%', label: '预警处置完成率' }
					],
					charts: ['柱状图：预警类型分布统计', '面积图：近半年预警事件趋势'],
					desc: '汇聚企业上报、抽检检测、网络舆情多源数据，针对火锅食材生产、加工、餐饮经营环节自动识别风险，分级推送预警信息，辅助监管部门开展风险处置，筑牢火锅产业食品安全防线。'
				}, {
					title: '价格行情分析｜能力详情',
					stats: [
						{ num: '56', label: '监测食材品类（类）' },
						{ num: '218', label: '行情采集点位（个）' },
						{ num: '186', label: '价格异动预警次数' },
						{ num: '5.1万', label: '行情日查询调用' }
					],
					charts: ['多线折线图：核心食材12个月价格走势', '面板：近期涨跌TOP食材异动列表'],
					desc: '汇聚产地、批发市场、企业交易多维价格数据，持续监测火锅核心食材价格波动，自动识别价格异动，为企业采购决策、产业宏观调控提供数据支撑。'
				}],
				priceList: [
						{ name: '江津花椒', change: 8.2, unit: '%' },
						{ name: '石柱辣椒', change: 5.6, unit: '%' },
						{ name: '内江牛油', change: 3.1, unit: '%' },
						{ name: '鲜毛肚', change: -4.5, unit: '%' },
						{ name: '火锅底料', change: -2.3, unit: '%' }
					],
				industryMetrics: [{ title: '产业链节点接入', value: '286' }, { title: '今日风险预警', value: '9' }, { title: '供需匹配成功率', value: '92.4%' }, { title: '项目履约率', value: '87%' }, { title: '监管协同事项', value: '31' }],
				industryActions: ['产业链监测', '风险工单', '项目调度', '标准核验', '供需撮合'],
				activeIndustryTab: '产业链监测',
				industryTabMetrics: {
					'产业链监测': [
						{ title: '产业链节点', value: '342' },
						{ title: '品类数', value: '61' },
						{ title: '本月异常告警', value: '13' },
						{ title: '已处理告警', value: '12' }
					],
					'风险工单': [
						{ title: '今日风险预警', value: '11' },
						{ title: '累计风险工单', value: '412' },
						{ title: '工单闭环处置率', value: '94.2%' },
						{ title: '平均处置时长', value: '4.6h' }
					],
					'项目调度': [
						{ title: '火锅文旅', value: '2个' },
						{ title: '食材加工厂', value: '32个' },
						{ title: '食材基地', value: '12个' },
						{ title: '物流体系', value: '5个' }
					],
					'标准核验': [
						{ title: '已接入标准库', value: '44套' },
						{ title: '累计核验批次', value: '12700批' },
						{ title: '核验通过率', value: '95.3%' },
						{ title: '不合规拦截数', value: '217批' }
					],
					'供需撮合': [
						{ title: '主体总数', value: '1750家' },
						{ title: '匹配成功率', value: '90.3%' },
						{ title: '累计撮合笔数', value: '1624笔' },
						{ title: '累计撮合交易额', value: '1.92亿' }
					]
				},
				riskTickets: [{ title: '冷链配送履约延迟', source: '物流监控 / 红色预警', status: '已派单', level: 'red' }, { title: '江津花椒价格波动', source: '价格行情 / 黄色预警', status: '待核验', level: 'yellow' }, { title: '某门店后厨抽检不合格', source: '食品安全 / 黄色预警', status: '整改中', level: 'yellow' }, { title: '某底料企业证照即将到期', source: '企业监管 / 蓝色提醒', status: '处理中', level: 'blue' }, { title: '集配中心冷库温度异常', source: '冷链监控 / 蓝色提醒', status: '已恢复', level: 'blue' }],
				projectProgress: [{ name: '火锅食材集配中心', percent: 82 }, { name: '底料智能工厂改造', percent: 64 }, { name: '火锅文旅示范街区', percent: 73 }, { name: '食安溯源平台扩面', percent: 91 }],
				analysisTabs: ['价格趋势预测', '季节性波动分析', '行情早报'],
				demandTabs: ['历史销量', '产能预测', '采购量预测'],
				industryColumns: [{
					title: '一产种养监测',
					value: '68',
					unit: '个基地',
					action: '查看基地画像',
					lines: ['基地分布、面积、产量接入', '按食材联动批次溯源', '采收周期与供应缺口预警']
				}, {
					title: '二产加工监管',
					value: '126',
					unit: '家企业',
					action: '查看加工企业',
					lines: ['产能、产品、资质统一管理', '生产流程与行业标准比对', '证照到期和合规异常提醒']
				}, {
					title: '三产门店运营',
					value: '2468',
					unit: '家门店',
					action: '查看门店热力',
					lines: ['经营、用工、合规检查汇总', '门店采购与上游供应匹配', '区域饱和度和消费热力分析']
				}, {
					title: '配套服务调度',
					value: '4',
					unit: '类服务',
					action: '发起服务撮合',
					lines: ['物流、金融、人才、质检服务调度', '企业信用画像与授信管理', '冷链仓配和抽检溯源协同']
				}]
			}
		},
		watch: {
			activeSection(value) {
				this.disposeCharts()
				this.$nextTick(() => {
					if (value === 'overview') this.renderOverview();
					if (value === 'ai') this.renderAi()
				})
			},
			analysisTab(val) {
				this.clearHighlightTimers();
				this.hideBackgroundTooltips();
				// 切走"价格趋势预测"时，销毁 echarts 实例，避免残留 canvas/tooltip 浮在列表之上
				if (val !== '价格趋势预测') this.disposeRef('marketChart');
				this.$nextTick(this.renderMarket)
				if (val === '价格趋势预测' && !this.aiChartData.price) {
					this.fetchAiChart('price', this.aiFilterParams());
				}
				if (val === '行情早报') this.fetchNewsPage('行情早报', this.aiFilterParams());
				if (val === '季节性波动分析') this.fetchSeasonalAnalysis(this.aiFilterParams());
			},
			demandTab(val) {
				this.clearHighlightTimers();
				this.$nextTick(this.renderDemand)
				const typeMap = { '历史销量': 'sales', '产能预测': 'capacity', '采购量预测': 'purchase' };
				const type = typeMap[val];
				if (type && !this.aiChartData[type]) this.fetchAiChart(type);
			},
			riskTab(val) {
				this.clearHighlightTimers();
				this.hideBackgroundTooltips();
				if (val !== '供应链断供') this.disposeRef('riskChart');
				if (val === '供应链断供') {
					this.$nextTick(this.renderRisk)
					if (!this.aiChartData['supply-risk']) this.fetchAiChart('supply-risk');
				}
				if (val === '食品安全' || val === '市场价格异动') {
					this.fetchNewsPage(val, this.aiFilterParams());
				}
			},
			contentTab(val) {
				this.fetchNewsPage(val, this.aiFilterParams());
			},
			pepper(val) {
				if (!val) return;
				// 食材变化：重新拉取该食材可选地区与基地，选项返回后刷新所有图表
				this.fetchAiOptions(val);
			},
			city() {
				// 地区变化：前端按 regionCode 过滤基地，重选第一个
				const filtered = this.filteredBases;
				if (filtered.length && !filtered.find(b => b.code === this.base)) {
					this.base = filtered[0].code;
				} else if (!filtered.length) {
					this.base = '';
				}
				this.refreshAiCharts();
			},
			base() {
				// 基地变化：整个页面所有图表按筛选条件刷新
				this.refreshAiCharts();
			}
		},
		mounted() {
			this.renderOverview()
			this.fetchBrainOverview()
			this.fetchNotices()
			this.fetchCallTrend('month')
			this.fetchCallTrend('year')
			this.fetchIndustry()
			this.fetchAiOptions()
		},
		beforeDestroy() {
			this.disposeCharts()
		},
		computed: {
			activeIndustryMetrics() {
				return this.industryTabMetrics[this.activeIndustryTab] || []
			},
			industryPopupData() {
				return (this.industryCapabilities[this.activeIndustryPopup] || {}).items || []
			},
			industryPopupSubtitle() {
				return (this.industryCapabilities[this.activeIndustryPopup] || {}).subtitle || ''
			},
			popupHasRanking() {
				const detail = this.recommendationDetails[this.activePopupIndex];
				if (detail && detail.ranking && detail.ranking.length) return true;
				const item = this.recommendations[this.activePopupIndex];
				return !!(item && item.code === 'price');
			},
			popupRankingData() {
				const detail = this.recommendationDetails[this.activePopupIndex];
				if (detail && detail.ranking && detail.ranking.length) return detail.ranking;
				return this.priceList;
			},
			filteredBases() {
				return this.aiOptions.bases.filter(b =>
					(!this.pepper || !b.ingredientCode || b.ingredientCode === this.pepper) &&
					(!this.city || !b.regionCode || b.regionCode === this.city)
				);
			}
		},
		methods: {
			goComponentOverview() {
				this.$router.push({
					name: 'ComponentOverview',
					query: this.$route.query
				})
			},
			changeSection(section) {
				this.activeSection = section
			},
			openIndustryPopup(title) {
				this.activeIndustryPopup = title
			},
			openNews(item) {
				this.clearHighlightTimers();
				this.hideBackgroundTooltips();
				this.newsDetail = item;
			},
			closeNews() {
				if (!this.newsDetail) return;
				this.newsDetail = null;
				this.$nextTick(this.resumeAiHighlight);
			},
			resumeAiHighlight() {
				if (this.activeSection !== 'ai' || this.activePopupIndex !== null || this.newsDetail) return;
				const marketElement = this.$refs.marketChart;
				const market = marketElement && echarts.getInstanceByDom(marketElement);
				if (market) this.startAutoHighlight(market, 'line', [12, 12]);

				const demandElement = this.$refs.demandChart;
				const demand = demandElement && echarts.getInstanceByDom(demandElement);
				if (demand) this.startAutoHighlight(demand, 'line', [12]);

				const riskElement = this.$refs.riskChart;
				const risk = riskElement && echarts.getInstanceByDom(riskElement);
				if (risk) this.startAutoHighlight(risk, 'line', [6]);
			},
			openPopup(index) {
				this.clearHighlightTimers();
				this.hideBackgroundTooltips();
				this.activePopupIndex = index;
				this.fetchComponentDetail(index);
			},
			fetchComponentDetail(index) {
				const item = this.recommendations[index];
				if (!item || !item.code) { this.renderPopupCharts(); return; }
				this.$request2('/admin-api/statistics/brain/component/get?code=' + item.code).then(res => {
					const value = (res.data && res.data.value) || {};
					this.$set(this.recommendationDetails, index, {
						code: value.code,
						title: value.title,
						desc: value.description,
						stats: (value.metrics || []).map(m => ({ num: m.value + m.unit, label: m.label })),
						charts: (value.charts || []).map(c => c.title),
						chartData: value.charts || [],
						ranking: value.ranking || []
					});
					this.renderPopupCharts();
				}).catch(() => { this.renderPopupCharts(); });
			},
			closePopup() {
				this.disposePopupCharts();
				this.activePopupIndex = null;
				if (this.activeSection === 'overview') this.renderOverview();
			},
			formatRankChange(item) {
				if (item == null) return '';
				const change = Number(item.change);
				const sign = change > 0 ? '+' : '';
				return sign + change + (item.unit || '');
			},
			hideBackgroundTooltips() {
				['categoryChart', 'trendChart', 'marketChart', 'demandChart', 'riskChart'].forEach(refName => {
					const element = this.$refs[refName];
					const chart = element && echarts.getInstanceByDom(element);
					if (chart) {
						chart.dispatchAction({ type: 'hideTip' });
						chart.dispatchAction({ type: 'downplay' });
					}
				});
			},
			renderPopupCharts() {
				this.$nextTick(() => {
					if (this.activePopupIndex === null) return;
					const options = this.getPopupChartOptions();
					const chart1 = this.getChart(this.$refs.popupChart1);
					if (chart1 && options[0]) {
						this.chartOption(chart1, options[0]);
						this.bindResize([chart1]);
					}
					const chart2 = this.$refs.popupChart2 && this.getChart(this.$refs.popupChart2);
					if (chart2 && options[1]) {
						this.chartOption(chart2, options[1]);
						this.bindResize([chart2]);
					}
				});
			},
			disposePopupCharts() {
				['popupChart1', 'popupChart2'].forEach(refName => {
					const element = this.$refs[refName];
					const chart = element && echarts.getInstanceByDom(element);
					if (chart) chart.dispose();
				});
			},
			getPopupChartOptions() {
				const detail = this.recommendationDetails[this.activePopupIndex];
				if (detail && detail.chartData && detail.chartData.length) {
					return detail.chartData.map(c => this.buildPopupChartOption(c)).filter(Boolean);
				}
				const axisLabel = { color: '#b3c8d4' };
				const axisLine = { lineStyle: { color: '#367aa5' } };
				const splitLine = { lineStyle: { color: 'rgba(68, 193, 239, .15)' } };
				const yBase = { type: 'value', axisLabel, splitLine, axisLine: { show: false } };
				const grid = { left: 46, right: 20, top: 18, bottom: 28 };
				const configs = [
					[{
						tooltip: { trigger: 'axis' },
						grid,
						xAxis: { type: 'category', data: ['辣椒', '花椒', '牛油', '毛肚', '底料'], axisLabel, axisLine },
						yAxis: yBase,
						series: [{ type: 'bar', data: [5200, 4300, 3800, 4100, 4060], itemStyle: { color: '#44c1ef' }, barWidth: '45%' }]
					}, {
						tooltip: { trigger: 'item' },
						series: [{
							type: 'pie', radius: ['40%', '70%'],
							data: [{ value: 35, name: '西南' }, { value: 25, name: '华中' }, { value: 20, name: '华北' }, { value: 20, name: '其他' }],
							label: { color: '#d8f1ff', fontSize: 11 },
							labelLine: { lineStyle: { color: '#44c1ef' } },
							itemStyle: { borderColor: '#082853', borderWidth: 2 },
							color: ['#168cff', '#36c6dc', '#9bc74b', '#e1b46d']
						}]
					}],
					[{
						tooltip: { trigger: 'axis' },
						grid,
						xAxis: { type: 'category', data: ['4月', '5月', '6月', '7月', '8月', '9月'], axisLabel, axisLine },
						yAxis: yBase,
						series: [{ type: 'line', data: [180, 210, 230, 245, 250, 253], smooth: true, symbolSize: 6, itemStyle: { color: '#44c1ef' }, lineStyle: { width: 2, color: '#44c1ef' }, areaStyle: { color: 'rgba(68, 193, 239, .12)' } }]
					}, {
						tooltip: { trigger: 'item' },
						series: [{
							type: 'pie', radius: ['40%', '70%'],
							data: [{ value: 30, name: '辣椒' }, { value: 20, name: '花椒' }, { value: 25, name: '牛油' }, { value: 15, name: '生鲜' }, { value: 10, name: '其他' }],
							label: { color: '#d8f1ff', fontSize: 11 },
							labelLine: { lineStyle: { color: '#44c1ef' } },
							itemStyle: { borderColor: '#082853', borderWidth: 2 },
							color: ['#168cff', '#36c6dc', '#9bc74b', '#e1b46d', '#f0996e']
						}]
					}],
					[{
						tooltip: { trigger: 'axis' },
						grid: { left: 50, right: 20, top: 18, bottom: 28 },
						xAxis: { type: 'category', data: ['农残超标', '添加剂违规', '证照异常', '冷链异常', '舆情风险'], axisLabel: { color: '#b3c8d4', fontSize: 10 }, axisLine },
						yAxis: yBase,
						series: [{ type: 'bar', data: [95, 72, 68, 55, 37], itemStyle: { color: '#f0996e' }, barWidth: '45%' }]
					}, {
						tooltip: { trigger: 'axis' },
						grid,
						xAxis: { type: 'category', data: ['4月', '5月', '6月', '7月', '8月', '9月'], axisLabel, axisLine },
						yAxis: yBase,
						series: [{ type: 'line', data: [42, 55, 48, 63, 58, 61], smooth: true, symbolSize: 6, itemStyle: { color: '#9bc74b' }, lineStyle: { width: 2, color: '#9bc74b' }, areaStyle: { color: 'rgba(155, 199, 75, .15)' } }]
					}],
					[{
						tooltip: { trigger: 'axis' },
						legend: { data: ['辣椒', '花椒', '牛油'], textStyle: { color: '#b3c8d4' }, top: 0, itemWidth: 10, itemHeight: 10 },
						grid: { left: 46, right: 20, top: 32, bottom: 28 },
						xAxis: { type: 'category', data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'], axisLabel: { color: '#b3c8d4', fontSize: 10 }, axisLine },
						yAxis: yBase,
						series: [
							{ name: '辣椒', type: 'line', data: [8.5, 9, 9.2, 9.5, 10, 10.5, 11, 10.8, 10.2, 10, 9.8, 9.5], smooth: true, symbolSize: 5, itemStyle: { color: '#44c1ef' }, lineStyle: { width: 2, color: '#44c1ef' } },
							{ name: '花椒', type: 'line', data: [12, 12.5, 13, 13.2, 13.5, 14, 13.8, 13.5, 13, 12.8, 12.5, 12.2], smooth: true, symbolSize: 5, itemStyle: { color: '#9bc74b' }, lineStyle: { width: 2, color: '#9bc74b' } },
							{ name: '牛油', type: 'line', data: [15, 15.2, 15.5, 16, 16.5, 17, 16.8, 16.5, 16, 15.8, 15.5, 15.2], smooth: true, symbolSize: 5, itemStyle: { color: '#e1b46d' }, lineStyle: { width: 2, color: '#e1b46d' } }
						]
					}, null]
				];
				return configs[this.activePopupIndex] || [];
			},
			buildPopupChartOption(chart) {
				if (!chart) return null;
				const axisLabel = { color: '#b3c8d4', fontSize: 10 };
				const axisLine = { lineStyle: { color: '#367aa5' } };
				const splitLine = { lineStyle: { color: 'rgba(68, 193, 239, .15)' } };
				const palette = ['#44c1ef', '#9bc74b', '#e1b46d', '#f0996e', '#168cff'];
				const labels = chart.labels || [];
				const series = chart.series || [];
				if (chart.kind === 'pie') {
					const s = series[0] || {};
					return {
						tooltip: { trigger: 'item' },
						series: [{
							type: 'pie',
							radius: ['40%', '70%'],
							data: labels.map((name, i) => ({ value: s.values ? s.values[i] : 0, name })),
							label: { color: '#d8f1ff', fontSize: 11 },
							labelLine: { lineStyle: { color: '#44c1ef' } },
							itemStyle: { borderColor: '#082853', borderWidth: 2 },
							color: palette
						}]
					};
				}
				const isBar = chart.kind === 'bar';
				const multi = series.length > 1;
				return {
					tooltip: { trigger: 'axis' },
					legend: multi ? { data: series.map(s => s.name), textStyle: { color: '#b3c8d4' }, top: 0, itemWidth: 10, itemHeight: 10 } : undefined,
					grid: { left: 46, right: 20, top: multi ? 32 : 18, bottom: 28 },
					xAxis: { type: 'category', data: labels, axisLabel, axisLine },
					yAxis: { type: 'value', axisLabel, splitLine, axisLine: { show: false } },
					series: series.map((s, i) => {
						const color = palette[i % palette.length];
						const opt = {
							name: s.name,
							type: isBar ? 'bar' : 'line',
							data: s.values || [],
							itemStyle: { color }
						};
						if (isBar) {
							opt.barWidth = '45%';
						} else {
							opt.smooth = true;
							opt.symbolSize = 5;
							opt.lineStyle = { width: 2, color };
							opt.areaStyle = { color: 'rgba(68, 193, 239, .12)' };
						}
						return opt;
					})
				};
			},
			chartOption(chart, option) {
				if (chart) {
					chart.clear();
					chart.setOption(option)
				}
			},
			getChart(element) {
				return element ? (echarts.getInstanceByDom(element) || echarts.init(element)) : null
			},
			disposeCharts() {
				this.clearHighlightTimers();
				['categoryChart', 'trendChart', 'marketChart', 'demandChart', 'riskChart', 'popupChart1', 'popupChart2'].forEach(refName => {
					this.disposeRef(refName)
				})
			},
			disposeRef(refName) {
				const element = this.$refs[refName];
				const chart = element && echarts.getInstanceByDom(element);
				if (chart) chart.dispose()
			},
			renderOverview() {
				this.$nextTick(() => {
					this.renderCategoryChart(this.ratios);
					this.renderTrendChart();
					this.startAutoHighlight(this.getChart(this.$refs.categoryChart), 'pie', [4]);
					this.startAutoHighlight(this.getChart(this.$refs.trendChart), 'line', [30])
			})
		},
			renderCategoryChart(ratios) {
				const category = this.getChart(this.$refs.categoryChart);
				if (!category) return;
				const data = (ratios && ratios.length)
					? ratios.map(r => ({ value: r.value, name: r.label }))
					: [{ value: 25, name: '基础技术' }, { value: 33, name: '行业专项' }, { value: 20, name: '数据服务' }, { value: 22, name: 'AI能力' }];
				this.chartOption(category, {
					tooltip: {
						trigger: 'item'
					},
					series: [{
						type: 'pie',
						radius: ['42%', '72%'],
						data,
						label: {
							color: '#d8f1ff',
							fontSize: 11
						},
						labelLine: {
							lineStyle: {
								color: '#44c1ef'
							}
						},
						itemStyle: {
							borderColor: '#082853',
							borderWidth: 2
						},
						color: ['#168cff', '#36c6dc', '#9bc74b', '#e1b46d']
					}]
				});
				this.bindResize([category]);
			},
			fetchBrainOverview() {
				this.$request2('/admin-api/statistics/brain/overview').then(res => {
					const value = (res.data && res.data.value) || {};
					this.ratios = value.ratios || [];
					const components = value.components || [];
					if (components.length) {
						this.recommendations = components.map(c => ({ code: c.code, title: c.title }));
					}
					if (this.activeSection === 'overview' && this.activePopupIndex === null) {
						this.renderCategoryChart(this.ratios);
					}
				}).catch(() => {});
			},
			fetchNotices() {
				this.$request2('/admin-api/statistics/brain/notices').then(res => {
					const value = (res.data && res.data.value) || [];
					if (Array.isArray(value) && value.length) {
						this.notifications = value.map(n => ({
							type: n.tag || n.title || '',
							content: (Array.isArray(n.content) && n.content[0]) || n.summary || ''
						}));
					}
				}).catch(() => {});
			},
			fetchCallTrend(period) {
				period = period || 'month';
				this.$request2('/admin-api/statistics/brain/call-trend?period=' + period).then(res => {
					const value = (res.data && res.data.value) || {};
					if (value && value.labels && value.labels.length) {
						const series = (value.series || []).find(s => s.values && s.values.length) || (value.series || [])[0] || {};
						this.$set(this.trendApiData, period, {
							labels: value.labels.slice(),
							values: (series.values || []).slice(),
							unit: value.unit || '万次'
						});
						if (this.trendTab === period && this.activeSection === 'overview' && this.activePopupIndex === null) {
							this.renderTrendChart();
						}
					}
				}).catch(() => {});
			},
			fetchIndustry() {
				this.$request2('/admin-api/statistics/brain/industry').then(res => {
					const value = (res.data && res.data.value) || {};
					const groups = value.groups || [];
					groups.forEach(g => {
						if (!g.title || !Array.isArray(g.metrics)) return;
						this.$set(this.industryTabMetrics, g.title, g.metrics.map(m => ({
							title: m.label || '',
							value: (m.value !== undefined && m.value !== null ? m.value : '') + (m.unit || '')
						})));
					});
					const caps = value.capabilities || [];
					caps.forEach(c => {
						if (!c.title) return;
						this.$set(this.industryCapabilities, c.title, {
							subtitle: c.subtitle || '',
							items: (c.items || []).map(it => ({
								name: it.name || '',
								desc: it.description || ''
							}))
						});
					});
				}).catch(() => {});
			},
			fetchAiOptions(ingredientCode, regionCode) {
				let url = '/admin-api/statistics/brain/ai/options';
				const params = [];
				if (ingredientCode) params.push('ingredientCode=' + ingredientCode);
				if (regionCode) params.push('regionCode=' + regionCode);
				if (params.length) url += '?' + params.join('&');
				this.$request2(url).then(res => {
					const value = (res.data && res.data.value) || {};
					if (Array.isArray(value.ingredients) && value.ingredients.length) {
						this.aiOptions.ingredients = value.ingredients;
					}
					if (Array.isArray(value.regions)) {
						this.aiOptions.regions = value.regions;
						// 食材变化后：当前地区不在新选项里则选第一个
						if (ingredientCode && this.aiOptions.regions.length &&
							!this.aiOptions.regions.find(r => r.code === this.city)) {
							this.city = this.aiOptions.regions[0].code;
						}
					}
					if (Array.isArray(value.bases)) {
						this.aiOptions.bases = value.bases;
					}
					// 重选默认基地：当前 base 不在过滤结果里则选第一个
					const filtered = this.filteredBases;
					if (filtered.length && !filtered.find(b => b.code === this.base)) {
						this.base = filtered[0].code;
					} else if (!filtered.length) {
						this.base = '';
					}
					// 选项刷新后兜底：若 city/base 未变（不触发 watch），仍需按新筛选刷新所有图表
					this.refreshAiCharts();
				}).catch(() => {});
			},
		switchTrendTab(tab) {
			if (this.trendTab === tab) return;
			this.clearHighlightTimers();
			this.hideBackgroundTooltips();
			this.trendTab = tab;
			this.renderTrendChart();
			if (!this.trendApiData[tab]) this.fetchCallTrend(tab);
			if (this.activeSection === 'overview' && this.activePopupIndex === null) {
				this.startAutoHighlight(this.getChart(this.$refs.categoryChart), 'pie', [4]);
				this.startAutoHighlight(this.getChart(this.$refs.trendChart), 'line', [tab === 'month' ? 30 : 12]);
			}
		},
		renderTrendChart() {
			const trend = this.getChart(this.$refs.trendChart);
			if (!trend) return;
			const isMonth = this.trendTab === 'month';
			const apiData = this.trendApiData[this.trendTab];
			let labels, data, unit;
			if (apiData && apiData.labels && apiData.labels.length) {
				labels = apiData.labels;
				data = apiData.values;
				unit = apiData.unit || '万次';
			} else {
				const monthData = [12.1, 12.3, 12.5, 12.8, 13.0, 11.8, 11.5, 12.2, 12.4, 12.6, 12.9, 13.1, 12.7, 12.0, 12.3, 12.5, 12.7, 13.0, 12.8, 11.9, 12.1, 12.4, 12.6, 12.8, 13.0, 12.9, 12.2, 12.4, 12.6, 12.7];
				const yearData = [355, 360, 368, 372, 375, 380, 378, 385, 382, 390, 388, 392];
				const monthLabels = [];
				for (let i = 14; i <= 43; i++) {
					monthLabels.push(i <= 30 ? '9/' + i : '10/' + (i - 30));
				}
				const yearLabels = ['去年10月', '11月', '12月', '今年1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月'];
				labels = isMonth ? monthLabels : yearLabels;
				data = isMonth ? monthData : yearData;
				unit = '万次';
			}
			this.chartOption(trend, {
				tooltip: { trigger: 'axis', formatter: '{b}<br/>调用量: {c}' + unit },
				grid: { left: 50, right: 20, top: 25, bottom: 30 },
				xAxis: {
					type: 'category',
					data: labels,
					axisLine: { lineStyle: { color: '#367aa5' } },
					axisLabel: { color: '#b3c8d4', fontSize: 10, interval: isMonth ? 4 : 'auto' }
				},
				yAxis: {
					type: 'value',
					axisLine: { show: false },
					axisLabel: { color: '#b3c8d4' },
					splitLine: { lineStyle: { color: 'rgba(68, 193, 239, .15)' } }
				},
				series: [{
						type: 'line',
						data: data,
						smooth: true,
						symbol: 'circle',
						symbolSize: isMonth ? 4 : 6,
						itemStyle: { color: '#44c1ef' },
						lineStyle: { width: 2, color: '#44c1ef' },
						areaStyle: { color: 'rgba(68, 193, 239, .15)' },
						emphasis: { itemStyle: { color: '#5fd4ff', borderColor: '#fff', borderWidth: 2 } }
					}]
			});
			this.bindResize([trend]);
		},
			renderAi() {
				this.$nextTick(() => {
					this.renderMarket();
					this.renderDemand();
					this.renderRisk();
					// 若图表数据未全部加载，按当前筛选条件拉取所有图表
					const allLoaded = ['price', 'sales', 'capacity', 'purchase', 'supply-risk'].every(t => this.aiChartData[t]);
					if (!allLoaded) this.refreshAiCharts();
					// 拉取当前可见的新闻分类
					this.refreshAiNews();
					// 季节性波动分析按需拉取
					if (this.analysisTab === '季节性波动分析') this.fetchSeasonalAnalysis();
				})
			},
			aiFilterParams() {
				return {
					ingredientCode: this.pepper,
					regionCode: this.city,
					baseCode: this.base
				};
			},
			computeAxisRange(values) {
				const nums = (values || []).filter(v => typeof v === 'number' && !isNaN(v));
				if (!nums.length) return { min: null, max: null };
				const dMin = Math.min(...nums);
				const dMax = Math.max(...nums);
				const pad = (dMax - dMin) * 0.15 || Math.max(Math.abs(dMax) * 0.1, 1);
				// 向远离 0 的方向取整边界
				const min = dMin >= 0 ? Math.max(0, Math.floor(dMin - pad)) : Math.floor(dMin - pad);
				const max = Math.ceil(dMax + pad);
				return { min, max };
			},
			refreshAiCharts() {
				// 防抖：pepper→city→base 链式变化时合并为一次拉取，使用最终筛选条件
				if (this._aiRefreshTimer) clearTimeout(this._aiRefreshTimer);
				this._aiRefreshTimer = setTimeout(() => {
					const params = this.aiFilterParams();
					['price', 'sales', 'capacity', 'purchase', 'supply-risk'].forEach(t => {
						this.fetchAiChart(t, params);
					});
					this.refreshAiNews(params);
					if (this.analysisTab === '季节性波动分析') this.fetchSeasonalAnalysis(params);
				}, 120);
			},
			mapNewsTagType(item) {
				const text = (item.level || '') + (item.tag || '');
				if (/红/.test(text)) return 'tag-red';
				if (/黄/.test(text)) return 'tag-yellow';
				if (/蓝/.test(text)) return 'tag-blue';
				if (/(价格下行|下跌|下行)/.test(text)) return 'tag-green';
				if (/(上涨|上行|偏强|回升|增长|坚挺)/.test(text)) return 'tag-up';
				if (/(下降|下行|偏弱|回落|下跌)/.test(text)) return 'tag-down';
				if (/(稳|平|持平|稳定|以稳)/.test(text)) return 'tag-flat';
				return 'tag-flat';
			},
			mapNewsItem(item) {
				return {
					id: item.id,
					title: item.title || '',
					summary: item.summary || '',
					content: Array.isArray(item.content) ? item.content : [],
					source: item.source || '',
					date: (item.publishTime || '').slice(0, 10),
					tag: item.tag || '',
					level: item.level || '',
					tagType: this.mapNewsTagType(item)
				};
			},
			assignNews(tabName, items) {
				if (tabName === '行情早报') {
					this.marketReports = items;
				} else if (tabName === '食品安全' || tabName === '市场价格异动') {
					this.$set(this.riskNews, tabName, items);
				} else {
					this.$set(this.contentNews, tabName, items);
				}
			},
			fetchNewsPage(tabName, params) {
				const code = this.newsCategoryMap[tabName];
				if (!code) return;
				let url = '/admin-api/statistics/brain/content/page?category=' + code + '&pageNo=1&pageSize=20';
				if (params) {
					if (params.ingredientCode) url += '&ingredientCode=' + params.ingredientCode;
					if (params.regionCode) url += '&regionCode=' + params.regionCode;
					if (params.baseCode) url += '&baseCode=' + params.baseCode;
				}
				this.$request2(url).then(res => {
					const value = (res.data && res.data.value) || {};
					const list = value.list || [];
					if (!list.length) return; // 空页保留兜底数据
					this.assignNews(tabName, list.map(it => this.mapNewsItem(it)));
				}).catch(() => {});
			},
			refreshAiNews(params) {
				const p = params || this.aiFilterParams();
				if (this.analysisTab === '行情早报') this.fetchNewsPage('行情早报', p);
				if (this.riskTab === '食品安全' || this.riskTab === '市场价格异动') this.fetchNewsPage(this.riskTab, p);
				this.fetchNewsPage(this.contentTab, p);
			},
			fetchSeasonalAnalysis(params) {
				let url = '/admin-api/statistics/brain/ai/seasonal-analysis';
				if (params) {
					const qs = [];
					if (params.ingredientCode) qs.push('ingredientCode=' + params.ingredientCode);
					if (params.regionCode) qs.push('regionCode=' + params.regionCode);
					if (params.baseCode) qs.push('baseCode=' + params.baseCode);
					if (qs.length) url += '?' + qs.join('&');
				}
				this.$request2(url).then(res => {
					const value = (res.data && res.data.value);
					if (!value || !value.items || !value.items.length) return; // 缺配置保留兜底
					this.seasonalAnalysis = value.items.map(it => ({ period: it.period || '', text: it.text || '' }));
				}).catch(() => {});
			},
			fetchAiChart(type, params) {
				let url = '/admin-api/statistics/brain/ai/chart?type=' + type;
				if (params) {
					if (params.ingredientCode) url += '&ingredientCode=' + params.ingredientCode;
					if (params.regionCode) url += '&regionCode=' + params.regionCode;
					if (params.baseCode) url += '&baseCode=' + params.baseCode;
				}
				this.$request2(url).then(res => {
					const value = (res.data && res.data.value) || {};
					if (value && value.labels && value.labels.length) {
						this.$set(this.aiChartData, type, {
							labels: value.labels.slice(),
							series: (value.series || []).map(s => ({ name: s.name, values: (s.values || []).slice() })),
							unit: value.unit || '',
							threshold: value.threshold,
							kind: value.kind
						});
						this.renderAiChartByType(type);
					}
				}).catch(() => {});
			},
			renderAiChartByType(type) {
				if (type === 'price' && this.analysisTab === '价格趋势预测') this.renderMarket();
				else if (type === 'sales' && this.demandTab === '历史销量') this.renderDemand();
				else if (type === 'capacity' && this.demandTab === '产能预测') this.renderDemand();
				else if (type === 'purchase' && this.demandTab === '采购量预测') this.renderDemand();
				else if (type === 'supply-risk' && this.riskTab === '供应链断供') this.renderRisk();
			},
			renderMarket() {
				if (this.analysisTab !== '价格趋势预测') return;
				const chart = this.getChart(this.$refs.marketChart);
				if (!chart) return;
				const api = this.aiChartData.price;
				let labels, seriesArr, unit;
				if (api && api.labels && api.labels.length) {
					labels = api.labels;
					seriesArr = api.series;
					unit = api.unit || '元/斤';
				} else {
					labels = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
					seriesArr = [
						{ name: '批发价', values: [9.8, 10.5, 11.6, 12.1, 11.4, 9.7, 8.8, 8.2, 8.6, 9.2, 9.5, 9.8] },
						{ name: '零售价', values: [11.6, 12.3, 13.4, 13.9, 13.1, 11.5, 10.6, 9.9, 10.2, 10.9, 11.2, 11.6] }
					];
					unit = '元/斤';
				}
				const palette = ['#44c1ef', '#9bc74b'];
				const series = seriesArr.map((s, i) => {
					const color = palette[i % palette.length];
					return {
						name: s.name,
						type: 'line',
						data: s.values,
						smooth: true,
						symbolSize: 6,
						itemStyle: { color },
						lineStyle: { width: 2, color },
						areaStyle: { color: 'rgba(68, 193, 239, .12)' },
						emphasis: { focus: 'series', symbolSize: 11, itemStyle: { borderColor: '#fff', borderWidth: 2, shadowBlur: 10, shadowColor: color } }
					};
				});
				// 动态计算 Y 轴范围，避免切换筛选后数据超出写死 max 被截断
				const flatVals = seriesArr.flatMap(s => s.values);
				const yRange = this.computeAxisRange(flatVals);
				this.chartOption(chart, {
					tooltip: {
						trigger: 'axis',
						formatter(params) {
							let s = params[0].name;
							params.forEach(p => { s += `<br/>${p.marker}${p.seriesName}：${p.value}${unit}`; });
							return s;
						}
					},
					legend: { data: seriesArr.map(s => s.name), top: 0, right: 10, itemWidth: 12, itemHeight: 8, textStyle: { color: '#b3c8d4', fontSize: 11 } },
					grid: { left: 50, right: 18, top: 30, bottom: 28 },
					xAxis: {
						type: 'category',
						boundaryGap: false,
						data: labels,
						axisLine: { lineStyle: { color: '#367aa5' } },
						axisLabel: { color: '#b3c8d4', fontSize: 10 }
					},
					yAxis: {
						type: 'value',
						min: yRange.min,
						max: yRange.max,
						axisLabel: { color: '#b3c8d4', fontSize: 10, formatter: '{value}元' },
						splitLine: { lineStyle: { color: 'rgba(68, 193, 239, .15)' } }
					},
					series
				});
				this.bindResize([chart]);
				this.startAutoHighlight(chart, 'line', series.map(s => s.data.length))
			},
				renderDemand() {
				const chart = this.getChart(this.$refs.demandChart);
				if (!chart) return;
				const months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
				const axisLabel = { color: '#b3c8d4', fontSize: 10 };
				const axisLine = { lineStyle: { color: '#367aa5' } };
				const splitLine = { lineStyle: { color: 'rgba(68, 193, 239, .15)' } };
				let option;
				if (this.demandTab === '历史销量') {
					// 历史销量：仅展示数值，不带单位
					const salesValues = ((this.aiChartData.sales && this.aiChartData.sales.series && this.aiChartData.sales.series[0] && this.aiChartData.sales.series[0].values) || [860, 810, 920, 880, 950, 980, 1050, 1120, 1180, 1240, 1300, 1420]);
					const salesRange = this.computeAxisRange(salesValues);
					option = {
						tooltip: { trigger: 'axis', formatter: '{b}<br/>销量：{c}' },
						grid: { left: 48, right: 18, top: 24, bottom: 28 },
						xAxis: { type: 'category', boundaryGap: false, data: months, axisLabel, axisLine },
						yAxis: { type: 'value', min: salesRange.min, max: salesRange.max, axisLabel, splitLine },
						series: [{
							name: '销量',
							type: 'line',
							data: salesValues,
							smooth: true,
							symbolSize: 6,
							itemStyle: { color: '#44c1ef' },
							lineStyle: { width: 2, color: '#44c1ef' },
							areaStyle: { color: 'rgba(68, 193, 239, .12)' },
							emphasis: { focus: 'series', symbolSize: 11, itemStyle: { borderColor: '#fff', borderWidth: 2 } }
						}]
					};
				} else if (this.demandTab === '产能预测') {
					// 产能预测：依据全国辣椒产季节律（南方冬春椒12-4月、西南6-10月、北方8月底-11月），10月为全年峰值，单位万吨
					const capValues = ((this.aiChartData.capacity && this.aiChartData.capacity.series && this.aiChartData.capacity.series[0] && this.aiChartData.capacity.series[0].values) || [120, 100, 130, 200, 280, 420, 520, 620, 680, 720, 480, 220]);
					const capRange = this.computeAxisRange(capValues);
					option = {
						tooltip: { trigger: 'axis', formatter: '{b}<br/>预测产能：{c}万吨' },
						grid: { left: 50, right: 18, top: 30, bottom: 28 },
						xAxis: { type: 'category', data: months, axisLabel, axisLine },
						yAxis: { type: 'value', min: capRange.min, max: capRange.max, axisLabel, splitLine },
						series: [{
							name: '预测产能',
							type: 'bar',
							data: capValues,
							barWidth: '48%',
							itemStyle: {
								borderRadius: [3, 3, 0, 0],
								color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#44c1ef' }, { offset: 1, color: 'rgba(68,193,239,.25)' }] }
							},
							emphasis: { itemStyle: { color: '#5fd4ff' } },
							markArea: {
								silent: true,
								label: { color: '#8ad4ff', fontSize: 10, position: 'insideTop', distance: 4 },
								data: [
									[{ name: '南方冬春椒', xAxis: '1月', itemStyle: { color: 'rgba(68,193,239,.07)' } }, { xAxis: '4月' }],
									[{ name: '夏秋集中上市', xAxis: '7月', itemStyle: { color: 'rgba(155,199,75,.09)' } }, { xAxis: '10月' }]
								]
							}
						}]
					};
				} else {
					// 采购量预测：全年逐月预估，单位吨
					const purValues = ((this.aiChartData.purchase && this.aiChartData.purchase.series && this.aiChartData.purchase.series[0] && this.aiChartData.purchase.series[0].values) || [380, 350, 360, 330, 360, 380, 420, 430, 450, 470, 460, 500]);
					const purRange = this.computeAxisRange(purValues);
					// 旺季峰值：取数据最大值所在月份
					let peakIdx = 0, peakVal = purValues[0];
					purValues.forEach((v, i) => { if (v > peakVal) { peakVal = v; peakIdx = i; } });
					const peakLabel = months[peakIdx] || '12月';
					option = {
						tooltip: { trigger: 'axis', formatter: '{b}<br/>预测采购量：{c}吨' },
						grid: { left: 50, right: 18, top: 24, bottom: 28 },
						xAxis: { type: 'category', boundaryGap: false, data: months, axisLabel, axisLine },
						yAxis: { type: 'value', min: purRange.min, max: purRange.max, axisLabel: { color: '#b3c8d4', fontSize: 10, formatter: '{value}吨' }, splitLine },
						series: [{
							name: '预测采购量',
							type: 'line',
							data: purValues,
							smooth: true,
							symbolSize: 6,
							itemStyle: { color: '#e1b46d' },
							lineStyle: { width: 2, color: '#e1b46d' },
							areaStyle: { color: 'rgba(225, 180, 109, .12)' },
							emphasis: { focus: 'series', symbolSize: 11, itemStyle: { borderColor: '#fff', borderWidth: 2 } },
							markPoint: {
								symbol: 'pin', symbolSize: 46,
								label: { fontSize: 10, color: '#082853' },
								itemStyle: { color: '#f7ff57' },
								data: [{ name: '旺季峰值', coord: [peakLabel, peakVal], value: peakVal }]
							}
						}]
					};
				}
				this.chartOption(chart, option);
				this.bindResize([chart]);
				this.startAutoHighlight(chart, 'line', [option.series[0].data.length])
			},
				renderRisk() {
					const chart = this.getChart(this.$refs.riskChart);
					if (!chart) return;
					const api = this.aiChartData['supply-risk'];
					const labels = (api && api.labels && api.labels.length) ? api.labels : ['10/03', '10/05', '10/07', '10/09', '10/11', '10/13'];
					const values = (api && api.series && api.series[0]) ? api.series[0].values : [42, 46, 52, 58, 68, 75];
					const threshold = (api && api.threshold !== null && api.threshold !== undefined) ? api.threshold : 70;
					this.chartOption(chart, {
					tooltip: { trigger: 'axis', formatter: '{b}<br/>断供风险：{c}%' },
					grid: {
					left: 42,
					right: 18,
					top: 28,
					bottom: 25
				},
					xAxis: {
						type: 'category',
						data: labels,
						axisLine: { lineStyle: { color: '#367aa5' } },
						axisLabel: { color: '#b3c8d4', fontSize: 10 }
					},
					yAxis: {
						type: 'value',
						min: 0,
						max: 100,
						axisLabel: { color: '#b3c8d4', fontSize: 10, formatter: '{value}%' },
						splitLine: { lineStyle: { color: 'rgba(68, 193, 239, .15)' } }
					},
					series: [{
					type: 'line',
					data: values,
						smooth: true,
						symbolSize: 6,
						lineStyle: { width: 2, color: '#f0996e' },
						itemStyle: { color: '#f0996e' },
						areaStyle: { color: 'rgba(240, 153, 110, .16)' },
						emphasis: { focus: 'series', symbolSize: 11, itemStyle: { borderColor: '#fff', borderWidth: 2, shadowBlur: 10, shadowColor: '#f0996e' } },
						markLine: {
							symbol: 'none',
							label: { color: '#f7ff57', fontSize: 10, formatter: '预警阈值 ' + threshold + '%' },
							lineStyle: { color: '#f7ff57', type: 'dashed' },
							data: [{ yAxis: threshold }]
						}
					}]
					})
					this.bindResize([chart]);
						this.startAutoHighlight(chart, 'line', [values.length])
				},
				bindResize(charts) {
					window.setTimeout(() => charts.forEach(chart => chart.resize()), 0)
				},
				clearHighlightTimers() {
					this.highlightTimers.forEach(t => clearInterval(t));
					this.highlightTimers = []
				},
				startAutoHighlight(chart, type, seriesDataCounts) {
					// 同一图表重渲染时先清掉旧定时器，避免多个轮询叠加导致高亮乱跳
					if (chart._highlightTimer) {
						clearInterval(chart._highlightTimer);
						const i = this.highlightTimers.indexOf(chart._highlightTimer);
						if (i > -1) this.highlightTimers.splice(i, 1);
					}
					let seriesIdx = 0;
					let dataIdx = -1;
					const total = seriesDataCounts.length;
					const tick = () => {
						dataIdx++;
						if (dataIdx >= seriesDataCounts[seriesIdx]) {
							dataIdx = 0;
							seriesIdx = (seriesIdx + 1) % total;
						}
						if (type === 'pie') {
							chart.dispatchAction({ type: 'downplay', seriesIndex: 0, dataIndex: dataIdx === 0 ? seriesDataCounts[0] - 1 : dataIdx - 1 });
							chart.dispatchAction({ type: 'highlight', seriesIndex: 0, dataIndex: dataIdx });
							chart.dispatchAction({ type: 'showTip', seriesIndex: 0, dataIndex: dataIdx });
						} else {
							chart.dispatchAction({ type: 'showTip', seriesIndex: seriesIdx, dataIndex: dataIdx });
							chart.dispatchAction({ type: 'highlight', seriesIndex: seriesIdx, dataIndex: dataIdx });
						}
					};
					tick();
					const timer = setInterval(tick, 2000);
					chart._highlightTimer = timer;
					this.highlightTimers.push(timer);
				}
		}
	}
</script>

<style scoped lang="scss">
	.ability-page {
		position: absolute;
		top: 102px;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		overflow: auto;
		// background: #182e63;
		color: #fff;
		font-family: 'Microsoft YaHei', sans-serif;
	}

	.side-menu {
		flex: 0 0 16.4%;
		min-width: 245px;
		background: #fff;
		color: #46535b;
	}

	.side-item {
		display: flex;
		align-items: center;
		height: 128px;
		padding-left: 34px;
		box-sizing: border-box;
		gap: 24px;
		font-size: clamp(22px, 1.7vw, 40px);
		cursor: pointer;
		transition: .2s;
	}

	.side-item.active {
		color: #2189f4;
		background: #dff5ff;
	}

	.side-icon {
		position: relative;
		display: inline-block;
		width: 45px;
		height: 45px;
		flex: 0 0 45px;
		border: 4px solid currentColor;
		box-sizing: border-box;
	}

	.home-icon {
		transform: rotate(45deg) scale(.72);
		border-radius: 2px;
		margin-right: -5px;
	}

	.home-icon:after {
		content: '';
		position: absolute;
		width: 22px;
		height: 24px;
		left: 7px;
		bottom: -4px;
		border: 4px solid currentColor;
		background: #fff;
	}

	.mail-icon {
		border-radius: 2px;
	}

	.mail-icon:after,
	.mail-icon:before {
		content: '';
		position: absolute;
		top: 10px;
		width: 27px;
		height: 4px;
		background: currentColor;
	}

	.mail-icon:before {
		left: 0;
		transform: rotate(36deg);
	}

	.mail-icon:after {
		right: 0;
		transform: rotate(-36deg);
	}

	.user-icon {
		border: 0;
		border-radius: 50%;
		width: 26px;
		height: 26px;
		margin-left: 9px;
		box-shadow: inset 0 0 0 4px currentColor;
	}

	.user-icon:after {
		content: '';
		position: absolute;
		width: 46px;
		height: 26px;
		left: -10px;
		top: 34px;
		border: 4px solid currentColor;
		border-bottom: 0;
		border-radius: 28px 28px 0 0;
	}

	.content-area {
		flex: 1;
		min-width: 0;
		padding: 70px 3.1% 90px;
		// box-sizing: border-box;
	}

	.metric-row {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		gap: 2%;
		margin-bottom: 95px;
		text-align: center;
	}

	.metric-title {
		font-size: clamp(18px, 1.8vw, 38px);
		white-space: nowrap;
	}

	.metric-value {
		margin-top: 70px;
		color: #fff;
		font-size: clamp(24px, 2.5vw, 52px);
		font-weight: 500;
	}

	.metric-desc {
		margin-top: 25px;
		font-size: clamp(14px, 1.25vw, 27px);
		white-space: nowrap;
	}

	.chart-grid,
	.ai-grid {
		display: grid;
		grid-template-columns: 1fr 1.7fr;
		gap: 3.4%;
	}

	.chart-panel {
		min-height: 390px;
		padding: 32px 4%;
		box-sizing: border-box;
		background: #fff;
		border: 2px solid #b7b7b7;
		color: #111;
	}

	.panel-title {
		font-size: clamp(18px, 1.4vw, 30px);
		line-height: 1.65;
	}

	.center-title {
		text-align: center;
	}

	.chart {
		width: 100%;
		height: 290px;
		margin-top: 20px;
	}

	.chart-category {
		margin-top: 0;
	}

	.section-title {
		margin: 90px 0 32px;
		font-size: clamp(24px, 2vw, 42px);
		font-weight: 400;
	}

	.recommend-row {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 3.5%;
	}

	.recommend {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 200px;
		background: #fff;
		color: #111;
		border: 2px solid #bbb;
		font-size: clamp(18px, 1.6vw, 34px);
	}

	.notice-title {
		margin-top: 80px;
	}

	.notice-panel {
		overflow: hidden;
		background: #fff;
		color: #111;
		border: 2px solid #bbb;
	}

	.industry-hero {
		height: 445px;
		padding: 48px 3%;
		box-sizing: border-box;
		background: linear-gradient(100deg, rgba(0, 60, 173, .9), rgba(0, 126, 234, .55)), url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E8%83%8C%E6%99%AF%402x.png') center/cover;
	}

	.industry-stats {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 2%;
	}

	.industry-stat {
		text-align: center;
	}

	.industry-stat strong {
		display: block;
		font-size: clamp(25px, 2.8vw, 56px);
	}

	.industry-stat span {
		display: block;
		margin-top: 12px;
		font-size: clamp(13px, 1.1vw, 22px);
	}

	.hero-callout {
		margin: 40px 0 0 auto;
		max-width: 560px;
		font-size: clamp(18px, 1.8vw, 38px);
		line-height: 1.5;
		text-align: center;
	}

	.hero-callout small {
		font-size: .65em;
	}

	.risk-grid {
		margin-top: 55px;
		grid-template-columns: 1fr 1.6fr;
	}

	.text-panel {
		min-height: 410px;
		padding: 90px 5%;
	}

	h3 {
		margin: 0 0 28px;
		font-size: clamp(21px, 1.5vw, 31px);
		font-weight: 400;
	}

	.text-panel p,
	.level-line,
	.project-copy p {
		font-size: clamp(18px, 1.35vw, 29px);
		line-height: 2;
	}

	.level-line {
		margin-top: 75px;
	}

	.project-panel {
		display: flex;
		align-items: center;
		min-height: 410px;
		padding: 45px;
		gap: 7%;
	}

	.project-copy {
		flex: 1;
	}

	.project-map {
		position: relative;
		display: grid;
		grid-template-columns: repeat(3, 88px);
		gap: 18px;
		width: 310px;
		padding: 26px 15px;
		color: #48bfff;
		background: #063d83;
		text-align: center;
	}

	.project-map span {
		padding: 14px 3px;
		border: 1px solid #188fe0;
		border-radius: 15px;
		font-size: 12px;
	}

	.project-map span.selected {
		color: #dffb4c;
		border-color: #dffb4c;
	}

	.project-map b {
		grid-column: 2;
		grid-row: 2;
		align-self: center;
		color: #fff;
		font-size: 14px;
	}

	.industry-capabilities {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 4%;
		margin-top: 62px;
	}

	.industry-column h2 {
		margin: 0 0 32px;
		font-size: clamp(18px, 1.65vw, 34px);
		font-weight: 400;
		text-align: center;
	}

	.column-body {
		min-height: 385px;
		padding: 55px 7%;
		background: #fff;
		color: #111;
		border: 2px solid #bbb;
	}

	.column-body p {
		margin: 0 0 18px;
		font-size: clamp(14px, 1.15vw, 24px);
		line-height: 1.75;
	}

	.ai-toolbar {
		display: flex;
		justify-content: flex-end;
		gap: 20px;
		margin: -70px 0 10px;
	}

	.ai-toolbar label {
		color: #111;
		font-size: 17px;
	}

	.ai-toolbar select {
		min-width: 120px;
		padding: 8px 14px;
		border: 1px solid #aaa;
		border-radius: 6px;
		font-size: 16px;
		background: #fff;
	}

	.ai-grid {
		grid-template-columns: 1fr 1fr;
		gap: 4%;
	}

	.ai-block h2 {
		margin: 0 0 18px;
		font-size: clamp(25px, 2.1vw, 44px);
		font-weight: 400;
	}

	.ai-panel {
		min-height: 500px;
		padding: 48px 4%;
	}

	.tabs {
		display: flex;
		border: 2px solid #2189f4;
		border-radius: 7px;
		overflow: hidden;
	}

	.tabs button {
		flex: 1;
		padding: 10px 4px;
		border: 0;
		border-right: 1px solid #2189f4;
		color: #2189f4;
		background: #fff;
		font-size: clamp(13px, 1.2vw, 24px);
		cursor: pointer;
	}

	.tabs button:last-child {
		border-right: 0;
	}

	.tabs button.selected {
		color: #fff;
		background: #2189f4;
	}

	.market-chart,
	.demand-chart {
		height: 370px;
	}

	.bottom-ai {
		margin-top: 85px;
	}

	.risk-visual {
		position: relative;
		height: 300px;
		margin-top: 30px;
		overflow: hidden;
		background: linear-gradient(#dcefff, #fff);
	}

	.risk-axis {
		position: absolute;
		bottom: 35px;
		left: 12%;
		width: 40%;
		height: 190px;
		border-bottom: 3px solid #2879d3;
		border-left: 3px solid #2879d3;
		transform: skewY(-20deg);
	}

	.risk-message {
		position: absolute;
		right: 0;
		top: 130px;
		padding: 25px 30px;
		border: 1px solid #fff;
		border-radius: 14px;
		font-size: clamp(14px, 1.1vw, 23px);
		background: rgba(255, 255, 255, .65);
	}

	.content-copy {
		overflow: hidden;
	}

	.content-copy h3 {
		margin-top: 28px;
		margin-bottom: 16px;
		font-weight: 700;
	}

	.content-copy p {
		margin: 0 0 16px;
		color: #222;
		font-size: clamp(14px, 1.1vw, 22px);
		line-height: 1.8;
	}

	/* 大屏页面采用与数据中心一致的信息密度，三个视图均限制在一屏内。 */
	@media (min-width: 701px) {
		.ability-page {
			overflow: hidden;
		}

		.side-menu {
			flex-basis: 220px;
			min-width: 220px;
		}

		.side-item {
			height: 78px;
			padding-left: 24px;
			gap: 14px;
			font-size: 20px;
		}

		.side-icon {
			width: 31px;
			height: 31px;
			flex-basis: 31px;
			border-width: 3px;
			transform: scale(.72);
		}

		.home-icon {
			margin-right: 0;
		}

		.home-icon:after {
			width: 15px;
			height: 17px;
			left: 5px;
			border-width: 3px;
		}

		.mail-icon:after,
		.mail-icon:before {
			top: 7px;
			width: 19px;
			height: 3px;
		}

		.user-icon {
			width: 21px;
			height: 21px;
			margin-left: 5px;
			box-shadow: inset 0 0 0 3px currentColor;
		}

		.user-icon:after {
			width: 34px;
			height: 20px;
			left: -7px;
			top: 27px;
			border-width: 3px;
		}

		.content-area {
			height: 100%;
			padding: 0 2.4% 18px;
			overflow: hidden;
		}

		.overview-view,
		.industry-view,
		.ai-view {
			display: flex;
			flex-direction: column;
			height: 100%;
			overflow: hidden;
		}

		.overview-view .notice-title,
		.industry-view .industry-capabilities,
		.ai-view .bottom-ai {
			margin-top: auto;
		}

		.metric-row {
			gap: 2%;
			margin-bottom: 18px;
		}

		.metric-title {
			font-size: 18px;
		}

		.metric-value {
			margin-top: 8px;
			font-size: 25px;
		}

		.metric-desc {
			margin-top: 5px;
			font-size: 12px;
		}

		.chart-grid,
		.ai-grid {
			gap: 2.4%;
		}

		.chart-panel {
			min-height: 238px;
			padding: 14px 2.5%;
			border-width: 1px;
		}

		.panel-title {
			font-size: 15px;
			line-height: 1.45;
		}

		.chart {
			height: 185px;
			margin-top: 0;
		}

		.section-title {
			margin: 17px 0 9px;
			font-size: 20px;
		}

		.recommend-row {
			gap: 2.5%;
		}

		.recommend {
			height: 76px;
			border-width: 1px;
			font-size: 17px;
		}

		.notice-title {
			margin-top: 17px;
		}

		.notice-panel {
			padding: 14px 20px;
			border-width: 1px;
			font-size: 14px;
		}

		.industry-hero {
			height: 145px;
			padding: 12px 2.5%;
		}

		.industry-stat strong {
			font-size: 24px;
		}

		.industry-stat span {
			margin-top: 5px;
			font-size: 12px;
		}

		.hero-callout {
			max-width: 390px;
			margin-top: 15px;
			font-size: 17px;
			line-height: 1.35;
		}

		.risk-grid {
			margin-top: 14px;
			gap: 2.4%;
		}

		.text-panel,
		.project-panel {
			min-height: 188px;
			height: 188px;
		}

		.text-panel {
			padding: 25px 4%;
		}

		h3 {
			margin-bottom: 10px;
			font-size: 16px;
		}

		.text-panel p,
		.level-line,
		.project-copy p {
			margin: 0;
			font-size: 13px;
			line-height: 1.75;
		}

		.level-line {
			margin-top: 22px;
		}

		.project-panel {
			padding: 16px 4%;
			gap: 4%;
		}

		.project-map {
			grid-template-columns: repeat(3, 62px);
			gap: 7px;
			width: 215px;
			padding: 10px;
		}

		.project-map span {
			padding: 8px 2px;
			border-radius: 8px;
			font-size: 10px;
		}

		.project-map b {
			font-size: 11px;
		}

		.industry-capabilities {
			gap: 2.5%;
			margin-top: 15px;
		}

		.industry-column h2 {
			margin-bottom: 8px;
			font-size: 17px;
		}

		.column-body {
			min-height: 195px;
			height: 195px;
			padding: 14px 6%;
			box-sizing: border-box;
			overflow: hidden;
			border-width: 1px;
		}

		.column-body p {
			margin-bottom: 5px;
			font-size: 12px;
			line-height: 1.55;
		}

		.ai-toolbar {
			gap: 10px;
			height: 30px;
			margin: -20px 0 8px;
		}

		.ai-toolbar label {
			font-size: 0;
		}

		.ai-toolbar select {
			min-width: 105px;
			padding: 5px 8px;
			border-radius: 4px;
			font-size: 13px;
		}

		.ai-grid {
			gap: 2.4%;
		}

		.ai-block h2 {
			margin-bottom: 7px;
			font-size: 20px;
		}

		.ai-panel {
			min-height: 260px;
			height: 260px;
			padding: 12px 3%;
		}

		.tabs {
			border-width: 1px;
			border-radius: 4px;
		}

		.tabs button {
			padding: 6px 3px;
			font-size: 13px;
		}

		.market-chart,
		.demand-chart {
			height: 205px;
		}

		.bottom-ai {
			margin-top: 14px;
		}

		.risk-visual {
			height: 205px;
			margin-top: 8px;
		}

		.risk-axis {
			bottom: 25px;
			height: 120px;
		}

		.risk-message {
			top: 82px;
			padding: 12px 15px;
			border-radius: 7px;
			font-size: 12px;
		}

		.content-copy h3 {
			margin: 10px 0 7px;
			font-size: 14px;
		}

		.content-copy p {
			margin-bottom: 5px;
			font-size: 11px;
			line-height: 1.5;
		}
	}

	@media (min-width: 701px) and (max-height: 800px) {
		.content-area {
			padding-top: 16px;
			padding-bottom: 14px;
		}

		.metric-row {
			margin-bottom: 10px;
		}

		.metric-title {
			font-size: 15px;
		}

		.metric-value {
			margin-top: 4px;
			font-size: 20px;
		}

		.metric-desc {
			margin-top: 2px;
			font-size: 10px;
		}

		.chart-panel {
			min-height: 190px;
			height: 190px;
			padding-top: 9px;
		}

		.chart {
			height: 148px;
		}

		.section-title {
			margin: 10px 0 6px;
			font-size: 17px;
		}

		.recommend {
			height: 58px;
			font-size: 14px;
		}

		.notice-title {
			margin-top: 10px;
		}

		.notice-panel {
			padding: 9px 15px;
			font-size: 12px;
		}

		.industry-hero {
			height: 112px;
			padding-top: 12px;
		}

		.industry-stat strong {
			font-size: 20px;
		}

		.hero-callout {
			margin-top: 8px;
			font-size: 14px;
		}

		.risk-grid {
			margin-top: 9px;
		}

		.text-panel,
		.project-panel {
			min-height: 158px;
			height: 158px;
		}

		.text-panel {
			padding-top: 17px;
		}

		.industry-capabilities {
			margin-top: 10px;
		}

		.column-body {
			min-height: 165px;
			height: 165px;
			padding-top: 10px;
		}

		.ai-toolbar {
			margin-top: -10px;
		}

		.ai-panel {
			min-height: 215px;
			height: 215px;
		}

		.market-chart,
		.demand-chart {
			height: 165px;
		}

		.bottom-ai {
			margin-top: 10px;
		}

		.risk-visual {
			height: 160px;
		}
	}

	@media (max-width: 1100px) {
		.side-menu {
			min-width: 190px;
		}

		.side-item {
			padding-left: 18px;
			gap: 12px;
		}

		.content-area {
			padding-right: 2%;
			padding-left: 2%;
		}

		.metric-row {
			margin-bottom: 45px;
		}

		.metric-value {
			margin-top: 28px;
		}

		.industry-capabilities {
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media (max-width: 700px) {
		.ability-page {
			top: 102px;
		}

		.side-menu {
			flex-basis: 130px;
			min-width: 130px;
		}

		.side-item {
			height: 100px;
			padding: 8px;
			flex-direction: column;
			justify-content: center;
			gap: 5px;
			font-size: 15px;
			text-align: center;
		}

		.side-icon {
			transform: scale(.6);
			margin: -8px 0;
		}

		.content-area {
			padding: 35px 15px 70px;
		}

		.metric-row {
			grid-template-columns: repeat(2, 1fr);
			gap: 28px 5px;
		}

		.metric-title,
		.metric-desc {
			white-space: normal;
		}

		.metric-value {
			margin-top: 10px;
		}

		.chart-grid,
		.ai-grid,
		.risk-grid {
			grid-template-columns: 1fr;
		}

		.overview-charts {
			gap: 18px;
		}

		.recommend-row {
			grid-template-columns: repeat(2, 1fr);
		}

		.recommend {
			height: 110px;
		}

		.industry-hero {
			height: auto;
			min-height: 330px;
		}

		.industry-stats {
			grid-template-columns: repeat(2, 1fr);
			gap: 25px;
		}

		.project-panel {
			flex-direction: column;
		}

		.ai-toolbar {
			margin: 0 0 25px;
			justify-content: flex-start;
			flex-wrap: wrap;
		}

		.industry-capabilities {
			grid-template-columns: 1fr;
		}

		.bottom-ai {
			margin-top: 40px;
		}
	}

	/* 复用数据中心的深色大屏视觉语言。 */
	.ability-page {
		// background: linear-gradient(180deg, rgba(0, 19, 53, .36), rgba(0, 25, 61, .28));
	}

	.side-menu {
		margin-left: 20px;
		margin-bottom: 20px;
		background: rgba(10, 125, 190, .25);
		border-radius: 12px;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .12);
		color: #b8e4f8;
	}

	.side-item {
		position: relative;
		border-bottom: 1px solid rgba(68, 193, 239, .1);
		font-size: 16px;
	}

	.side-item:hover {
		color: #fff;
		background: rgba(21, 115, 190, .16);
	}

	.side-item.active {
		color: #fff;
		background: linear-gradient(90deg, rgba(23, 137, 213, .66), rgba(25, 126, 190, .2));
		box-shadow: inset 3px 0 #44c1ef, inset 0 0 20px rgba(24, 132, 255, .18);
	}

	.side-item.active:after {
		content: '';
		position: absolute;
		right: 0;
		width: 0;
		height: 0;
		border-top: 8px solid transparent;
		border-right: 8px solid #44c1ef;
		border-bottom: 8px solid transparent;
	}

	.home-icon:after {
		background: #175a8c;
	}

	.side-item.active .home-icon:after {
		background: #197bb8;
	}

	.metric {
		position: relative;
		padding: 7px 8px 10px;
		background: linear-gradient(180deg, rgba(10, 125, 190, .13), rgba(10, 125, 190, 0));
	}

	.metric-detail {
		position: absolute;
		top: 2px;
		right: 6px;
		font-size: 12px;
		color: #44c1ef;
		cursor: pointer;
		z-index: 2;
	}

	.metric-detail:hover {
		color: #fff;
		text-shadow: 0 0 8px rgba(73, 223, 255, .6);
	}

	.metric-clickable {
		cursor: pointer;
	}

	.metric:after {
		content: '';
		position: absolute;
		right: 12%;
		bottom: 0;
		left: 12%;
		height: 1px;
		background: linear-gradient(90deg, transparent, #44c1ef, transparent);
	}

	.metric-title {
		color: #d8f1ff;
		text-shadow: 0 0 10px rgba(73, 223, 255, .35);
	}

	.metric-value,
	.industry-stat strong {
		font-family: DINPro, DIN, sans-serif;
		background: linear-gradient(180deg, #fff 15%, #f7ff57 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.metric-desc,
	.industry-stat span {
		color: #8ad4ff;
	}

	.metric-value-split {
		display: flex;
		justify-content: center;
		gap: 8px;
	}

	.metric-value-split i {
		font-style: normal;
		opacity: .5;
	}

	.metric-desc-split {
		display: flex;
		justify-content: center;
		gap: 8px;
	}

	.metric-desc-split i {
		font-style: normal;
		opacity: .3;
	}

	.chart-panel,
	.recommend,
	.notice-panel,
	.column-body {
		position: relative;
		border: 1px solid rgba(68, 193, 239, .42);
		border-radius: 4px;
		background:
			linear-gradient(135deg, rgba(68, 193, 239, .14), transparent 22%) top left,
			linear-gradient(315deg, rgba(68, 193, 239, .1), transparent 22%) bottom right,
			rgba(10, 63, 113, .34);
		background-size: 100% 100%;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .12), 0 0 10px rgba(0, 14, 40, .22);
		color: #d8f1ff;
	}

	.chart-panel:before,
	.recommend:before,
	.notice-panel:before,
	.column-body:before {
		content: '';
		position: absolute;
		top: -1px;
		left: -1px;
		width: 28px;
		height: 10px;
		border-top: 2px solid #44c1ef;
		border-left: 2px solid #44c1ef;
	}

	.panel-title {
		padding-left: 10px;
		border-left: 3px solid #9bc74b;
		color: #d8f1ff;
	}

	.center-title {
		border-left: 0;
	}

	.section-title,
	.ai-block h2,
	.industry-column h2 {
		box-sizing: border-box;
		color: #f6f9fe;
		text-shadow: 0 0 10px rgba(73, 223, 255, .32);
	}

	.section-title {
		width: 270px;
		padding: 4px 0 4px 36px;
		background: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E6%A0%87%E9%A2%98%402x.png') center / 100% 100% no-repeat;
	}

	.recommend {
		cursor: pointer;
		color: #d8f1ff;
		transition: border-color .2s, background .2s;
	}

	.recommend:hover {
		border-color: #9bc74b;
		background: rgba(18, 104, 166, .48);
		color: #f7ff57;
	}

	.notice-panel {
		color: #b3c8d4;
		height: 56px;
	}

	.notice-scroll {
		padding: 4px 0;
		animation: noticeScroll 18s linear infinite;
	}

	.notice-item {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 4px 16px;
		font-size: 14px;
		white-space: nowrap;
	}

	.notice-type {
		flex-shrink: 0;
		padding: 2px 8px;
		border-radius: 3px;
		font-size: 12px;
		font-weight: 500;
		color: #fff;
	}

	.notice-type.组件更新 {
		background: #168cff;
	}

	.notice-type.接口维护 {
		background: #e1b46d;
	}

	.notice-type.权限申请 {
		background: #9bc74b;
	}

	.notice-type.安全预警 {
		background: #f0996e;
	}

	.notice-content {
		color: #d8f1ff;
	}

	@keyframes noticeScroll {
		0% {
			transform: translateY(0);
		}
		100% {
			transform: translateY(-50%);
		}
	}

	.chart-unit {
		font-size: 12px;
		color: #8ad4ff;
		font-weight: 400;
	}

	.trend-tabs {
		display: flex;
		gap: 4px;
	}

	.trend-tabs button {
		padding: 4px 14px;
		border: 1px solid rgba(68, 193, 239, .42);
		border-radius: 3px;
		background: transparent;
		color: #8ad4ff;
		font-size: 13px;
		cursor: pointer;
		transition: all .2s;
	}

	.trend-tabs button:hover {
		color: #fff;
		border-color: #44c1ef;
	}

	.trend-tabs button.active {
		background: rgba(68, 193, 239, .22);
		color: #fff;
		border-color: #44c1ef;
	}

	.industry-hero {
		border: 1px solid rgba(68, 193, 239, .4);
		background:
			linear-gradient(90deg, rgba(5, 47, 101, .9), rgba(4, 83, 151, .48)),
			url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E8%83%8C%E6%99%AF%402x.png') center / cover;
		box-shadow: inset 0 0 35px rgba(24, 132, 255, .18);
	}

	.hero-callout {
		color: #d8f1ff;
	}

	.column-body p,
	.text-panel p,
	.level-line,
	.project-copy p {
		color: #b3c8d4;
	}

	.industry-column h2 {
		padding-bottom: 7px;
		border-bottom: 1px solid rgba(68, 193, 239, .42);
	}

	.ai-toolbar label {
		color: #8ad4ff;
	}

	.ai-toolbar select {
		border: 1px solid rgba(68, 193, 239, .55);
		color: #d8f1ff;
		background: rgba(5, 35, 85, .9);
		outline: none;
	}

	.ai-toolbar option {
		color: #d8f1ff;
		background: #052355;
	}

	.tabs {
		gap: 6px;
		border: 0;
		border-radius: 0;
	}

	.tabs button {
		border: 0;
		color: #b8e9ff;
		background: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E6%9C%AA%E9%80%89%E4%B8%AD%402x.png') center / 100% 100% no-repeat;
	}

	.tabs button:last-child {
		border: 0;
	}

	.tabs button:hover {
		color: #fff;
	}

	.tabs button.selected {
		color: #fff;
		background: url('https://xlqy.obs.cn-southwest-2.myhuaweicloud.com/screen/%E9%80%89%E6%8B%A9%E6%A1%862%E9%80%89%E4%B8%AD%402x.png') center / 100% 100% no-repeat;
	}

	.risk-visual {
		border: 1px solid rgba(68, 193, 239, .18);
		background: linear-gradient(180deg, rgba(14, 102, 167, .28), rgba(2, 28, 69, .52));
	}

	.risk-chart {
		width: 100%;
		height: 100%;
	}

	.risk-message {
		top: 8px;
		right: 10px;
		padding: 5px 9px;
		border-color: rgba(68, 193, 239, .4);
		color: #f7ff57;
		font-size: 10px;
		background: rgba(6, 50, 100, .86);
	}

	.content-copy h3 {
		color: #f7ff57;
	}

	.content-copy p {
		color: #b3c8d4;
	}

	.content-copy p b {
		color: #8ad4ff;
	}

	/* AI 面板：季节性文字解说、新闻/测报列表与新闻详情弹窗。 */
	.season-panel,
	.news-list {
		height: 370px;
		margin-top: 14px;
		overflow-y: auto;
		box-sizing: border-box;
	}

	.season-panel::-webkit-scrollbar,
	.news-list::-webkit-scrollbar,
	.news-popup::-webkit-scrollbar {
		width: 5px;
	}

	.season-panel::-webkit-scrollbar-thumb,
	.news-list::-webkit-scrollbar-thumb,
	.news-popup::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background: rgba(68, 193, 239, .35);
	}

	.season-item {
		padding: 10px 12px 10px 14px;
		margin-bottom: 10px;
		border-left: 3px solid #44c1ef;
		background: linear-gradient(90deg, rgba(68, 193, 239, .1), rgba(68, 193, 239, 0));
	}

	.season-period {
		margin-bottom: 4px;
		color: #f7ff57;
		font-size: 14px;
		font-weight: 600;
	}

	.season-item p {
		margin: 0;
		color: #b3c8d4;
		font-size: 13px;
		line-height: 1.7;
	}

	.news-list {
		display: flex;
		flex-direction: column;
	}

	.news-item {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px 8px;
		border-bottom: 1px dashed rgba(68, 193, 239, .18);
		cursor: pointer;
		transition: background .2s;
	}

	.news-item:hover {
		background: rgba(68, 193, 239, .1);
	}

	.news-item:last-child {
		border-bottom: 0;
	}

	.news-tag {
		flex: 0 0 auto;
		padding: 2px 8px;
		border-radius: 2px;
		font-size: 11px;
		font-style: normal;
		line-height: 1.6;
		color: #fff;
		white-space: nowrap;
	}

	.tag-up,
	.tag-red {
		background: rgba(224, 76, 76, .85);
	}

	.tag-yellow {
		color: #3a2a05;
		background: rgba(225, 180, 109, .92);
	}

	.tag-down,
	.tag-green {
		background: rgba(82, 179, 122, .88);
	}

	.tag-flat,
	.tag-blue {
		background: rgba(68, 150, 239, .88);
	}

	.news-item-body {
		flex: 1;
		min-width: 0;
	}

	.news-title {
		color: #e6f4ff;
		font-size: 14px;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.news-summary {
		display: -webkit-box;
		margin-top: 4px;
		color: #b3c8d4;
		font-size: 13px;
		line-height: 1.6;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.news-meta {
		margin-top: 4px;
		color: #6f8fa8;
		font-size: 11px;
	}

	.news-arrow {
		flex: 0 0 auto;
		color: #44c1ef;
		font-size: 12px;
		white-space: nowrap;
	}

	.news-item:hover .news-arrow {
		color: #fff;
	}

	.news-popup {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 640px;
		max-width: 90vw;
		max-height: 82vh;
		overflow-y: auto;
		padding: 26px 28px;
		border: 1px solid #3b88e8;
		border-radius: 10px;
		background:
			linear-gradient(135deg, rgba(68, 193, 239, .14), transparent 22%) top left,
			linear-gradient(315deg, rgba(68, 193, 239, .1), transparent 22%) bottom right,
			rgba(10, 32, 78, .97);
		background-size: 100% 100%;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .18), 0 0 40px rgba(0, 14, 40, .6);
		z-index: 9999;
	}

	.news-popup-title {
		padding-right: 30px;
		color: #fff;
		font-size: 20px;
		font-weight: 600;
		line-height: 1.5;
	}

	.news-popup-meta {
		display: flex;
		align-items: center;
		gap: 14px;
		margin: 12px 0 18px;
		padding-bottom: 12px;
		border-bottom: 1px solid rgba(68, 193, 239, .25);
		color: #8ad4ff;
		font-size: 13px;
	}

	.news-popup-body p {
		margin: 0 0 12px;
		color: #c8def0;
		font-size: 15px;
		line-height: 1.95;
		text-indent: 2em;
	}

	/* 火锅行业专项能力 - 能力清单弹窗 */
	.industry-popup {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 720px;
		max-width: 90vw;
		max-height: 86vh;
		overflow-y: auto;
		padding: 26px 30px;
		border: 1px solid #3b88e8;
		border-radius: 10px;
		background:
			linear-gradient(135deg, rgba(68, 193, 239, .14), transparent 22%) top left,
			linear-gradient(315deg, rgba(68, 193, 239, .1), transparent 22%) bottom right,
			rgba(10, 32, 78, .97);
		background-size: 100% 100%;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .18), 0 0 40px rgba(0, 14, 40, .6);
		z-index: 9999;
	}

	.industry-popup-title {
		padding-right: 30px;
		color: #84d1ff;
		font-size: 22px;
		font-weight: 600;
		text-shadow: 0 0 10px rgba(73, 223, 255, .32);
	}

	.industry-popup-sub {
		margin: 10px 0 16px;
		padding-bottom: 12px;
		border-bottom: 1px solid rgba(68, 193, 239, .25);
		color: #8ad4ff;
		font-size: 14px;
	}

	.industry-popup-list {
		margin: 0;
		padding: 0;
		list-style: none;
		counter-reset: cap;
	}

	.industry-popup-list li {
		position: relative;
		padding: 10px 0 10px 38px;
		border-bottom: 1px dashed rgba(68, 193, 239, .18);
		counter-increment: cap;
	}

	.industry-popup-list li:last-child {
		border-bottom: none;
	}

	.industry-popup-list li::before {
		content: counter(cap);
		position: absolute;
		left: 0;
		top: 12px;
		width: 26px;
		height: 26px;
		border-radius: 50%;
		border: 1px solid #44c1ef;
		color: #f7ff57;
		font-size: 13px;
		font-weight: bold;
		line-height: 24px;
		text-align: center;
		background: rgba(24, 64, 134, .4);
	}

	.industry-popup-list .cap-name {
		margin-bottom: 4px;
		color: #fff;
		font-size: 16px;
		font-weight: 600;
	}

	.industry-popup-list .cap-desc {
		color: #b8d2e8;
		font-size: 14px;
		line-height: 1.8;
	}

	/* 顶部标题栏占用 102px，右侧内容使用剩余高度铺满。 */
	@media (min-width: 701px) {
		.ability-page {
			height: calc(100vh - 102px);
			max-height: calc(100vh - 102px);
			bottom: auto;
			box-sizing: border-box;
			overflow: hidden;
		}

		.content-area {
			flex: 1 1 auto;
			height: 100%;
			min-height: 0;
			max-height: 100%;
			box-sizing: border-box;
			padding-top: 0;
			padding-bottom: 18px;
			overflow: hidden;
		}

		.overview-view,
		.industry-view,
		.ai-view {
			min-height: 0;
		}

		.overview-view {
			display: grid;
			grid-template-rows: auto 1fr auto auto auto auto;
			gap: 12px;
		}

		.overview-view .metric-row,
		.overview-view .chart-grid,
		.overview-view .section-title,
		.overview-view .recommend-row,
		.overview-view .notice-panel {
			min-height: 0;
			margin-top: 0;
			margin-bottom: 0;
		}
		.overview-view .chart-grid,
		.overview-view .chart-panel {
			height: 100%;
		}
		.overview-view .chart-panel {
			min-height: 0;
		}
		.overview-view .chart {
			height: calc(100% - 28px);
		}
		.overview-view .recommend {
		}
		.overview-view .notice-title {
			margin-top: 0;
		}
		.overview-view .notice-panel {
			min-height: 36px;
			height: 36px;
		}

		.industry-view {
			display: grid;
			grid-template-rows: 145px minmax(0, 1fr) minmax(0, 1fr);
			gap: 14px;
		}
		.industry-view .industry-hero,
		.industry-view .risk-grid,
		.industry-view .industry-capabilities {
			min-height: 0;
			margin-top: 0;
		}
		.industry-view .risk-grid {
			height: 100%;
		}
		.industry-view .text-panel,
		.industry-view .project-panel {
			height: 100%;
			min-height: 0;
		}
		.industry-view .industry-capabilities {
			height: 100%;
		}
		.industry-view .column-body {
			height: calc(100% - 35px);
			min-height: 0;
		}

		.ai-view {
			position: relative;
			display: grid;
			grid-template-rows: minmax(0, 1fr) minmax(0, 1fr);
			gap: 14px;
		}
		.ai-view .ai-toolbar,
		.ai-view .ai-grid,
		.ai-view .ai-block,
		.ai-view .ai-panel {
			min-height: 0;
			max-height: 100%;
		}
		.ai-view .ai-toolbar {
			position: absolute;
			top: 0;
			right: 0;
			z-index: 5;
			margin: 0;
		}
		.ai-view .bottom-ai {
			margin-top: 0;
		}
		.ai-view .ai-block {
			display: flex;
			flex-direction: column;
		}
		.ai-view .ai-panel {
			height: 100%;
			flex: 1;
		}
		.ai-view .market-chart,
		.ai-view .demand-chart {
			height: calc(100% - 32px);
		}
		.ai-view .risk-visual {
			height: calc(100% - 30px);
		}
		.ai-view .season-panel,
		.ai-view .news-list {
			height: calc(100% - 52px);
			margin-top: 20px;
		}
		.ai-view .season-item {
			padding: 7px 10px;
			margin-bottom: 7px;
		}
		.ai-view .season-period {
			font-size: 12.5px;
		}
		.ai-view .season-item p {
			font-size: 11.5px;
			line-height: 1.55;
		}
		.ai-view .news-item {
			padding: 7px 6px;
			gap: 8px;
		}
		.ai-view .news-title {
			font-size: 13px;
		}
		.ai-view .news-summary {
			margin-top: 2px;
			font-size: 12px;
			line-height: 1.5;
		}
		.ai-view .news-meta {
			margin-top: 2px;
			font-size: 10px;
		}
		.ai-view .news-tag {
			padding: 1px 6px;
			font-size: 10px;
		}
		.ai-view .news-arrow {
			font-size: 11px;
		}
	}

	/* 火锅行业专项能力：横幅信息区、工单列表、进度条与能力卡片。 */
	.industry-hero {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 10px;
	}

	.hero-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 24px;
	}

	.hero-title {
		margin: 0;
		font-size: 22px;
		font-weight: 500;
		color: #f6f9fe;
		text-shadow: 0 0 10px rgba(73, 223, 255, .32);
	}

	.hero-desc {
		margin: 4px 0 0;
		color: #8ad4ff;
		font-size: 13px;
	}

	.hero-action-row {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-end;
		gap: 10px;
	}

	.hero-action-row button,
	.column-body button {
		padding: 7px 18px;
		border: 1px solid rgba(68, 193, 239, .55);
		color: #d8f1ff;
		background: rgba(10, 63, 113, .5);
		font-size: 13px;
		font-family: inherit;
		cursor: pointer;
		transition: all .2s;
	}

	.hero-action-row button:hover,
	.column-body button:hover {
		color: #fff;
		border-color: #44c1ef;
		background: linear-gradient(90deg, rgba(23, 137, 213, .66), rgba(25, 126, 190, .25));
		box-shadow: 0 0 12px rgba(68, 193, 239, .35);
	}

	.hero-action-row button.active {
		color: #fff;
		border-color: #44c1ef;
		background: linear-gradient(90deg, rgba(23, 137, 213, .85), rgba(25, 126, 190, .4));
		box-shadow: 0 0 14px rgba(68, 193, 239, .5);
	}

	.panel-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
	}

	.panel-extra {
		color: #8ad4ff;
		font-size: 12px;
	}

	.risk-workbench,
	.project-workbench {
		display: flex;
		flex-direction: column;
	}

	.risk-list,
	.progress-list {
		flex: 1;
		min-height: 0;
		margin-top: 8px;
		overflow-y: auto;
		scrollbar-width: none;
	}

	.risk-list::-webkit-scrollbar,
	.progress-list::-webkit-scrollbar {
		display: none;
	}

	.risk-ticket {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		margin-top: 10px;
		padding: 9px 12px;
		border-left: 3px solid #44c1ef;
		background: rgba(10, 63, 113, .38);
		font-size: 13px;
		transition: background .2s;
	}

	.risk-ticket:hover {
		background: rgba(18, 104, 166, .48);
	}

	.ticket-info {
		min-width: 0;
	}

	.ticket-info b {
		display: block;
		overflow: hidden;
		color: #f6f9fe;
		font-weight: 500;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.ticket-info span {
		display: block;
		margin-top: 3px;
		color: #8ad4ff;
		font-size: 12px;
	}

	.risk-ticket strong {
		flex: 0 0 auto;
		padding: 3px 10px;
		border: 1px solid rgba(68, 193, 239, .55);
		border-radius: 3px;
		color: #8ad4ff;
		font-size: 12px;
		font-weight: 400;
		background: rgba(68, 193, 239, .1);
	}

	.risk-ticket.red {
		border-left-color: #ff5f5f;
	}

	.risk-ticket.red strong {
		color: #ff8585;
		border-color: rgba(255, 95, 95, .6);
		background: rgba(255, 95, 95, .12);
	}

	.risk-ticket.yellow {
		border-left-color: #f7ff57;
	}

	.risk-ticket.yellow strong {
		color: #f7ff57;
		border-color: rgba(247, 255, 87, .55);
		background: rgba(247, 255, 87, .1);
	}

	.project-progress {
		margin-top: 12px;
	}

	.progress-line {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		gap: 12px;
		font-size: 13px;
	}

	.progress-line span {
		overflow: hidden;
		color: #d8f1ff;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.progress-line b {
		color: #f7ff57;
		font-family: DINPro, DIN, sans-serif;
		font-weight: 500;
	}

	.progress-track {
		height: 8px;
		margin-top: 6px;
		border-radius: 4px;
		background: rgba(68, 193, 239, .14);
		overflow: hidden;
	}

	.progress-track i {
		display: block;
		height: 100%;
		border-radius: 4px;
		background: linear-gradient(90deg, #168cff, #44c1ef);
		box-shadow: 0 0 8px rgba(68, 193, 239, .55);
		transition: width .6s;
	}

	.function-main {
		display: flex;
		align-items: baseline;
		gap: 8px;
		padding-bottom: 10px;
		border-bottom: 1px dashed rgba(68, 193, 239, .25);
	}

	.function-main strong {
		font-family: DINPro, DIN, sans-serif;
		font-size: 28px;
		background: linear-gradient(180deg, #fff 15%, #f7ff57 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.function-main span {
		color: #8ad4ff;
		font-size: 13px;
	}

	.column-body {
		display: flex;
		flex-direction: column;
	}

	.column-body button {
		margin-top: auto;
		padding: 7px 0;
	}

	.industry-column:hover .column-body {
		border-color: #44c1ef;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .2), 0 0 14px rgba(68, 193, 239, .3);
	}

	/* 桌面端紧凑布局：工单与进度面板撑满网格行，横幅压缩字号。 */
	@media (min-width: 701px) {
		.hero-title {
			font-size: 19px;
		}

		.hero-desc {
			margin-top: 3px;
			font-size: 12px;
		}

		.hero-action-row button {
			padding: 6px 16px;
		}

		.industry-view .risk-grid .chart-panel {
			height: 100%;
			min-height: 0;
		}
	}

	@media (min-width: 701px) and (max-height: 800px) {
		.industry-hero {
			gap: 6px;
		}

		.hero-desc {
			display: none;
		}

		.hero-action-row button {
			padding: 5px 14px;
			font-size: 12px;
		}

		.risk-ticket {
			margin-top: 8px;
			padding: 7px 10px;
		}

		.progress-line {
			font-size: 12px;
		}

		.function-main {
			padding-bottom: 6px;
		}

		.function-main strong {
			font-size: 24px;
		}

		.column-body p {
			margin-bottom: 4px;
			font-size: 11px;
			line-height: 1.5;
		}

		.column-body button {
			padding: 5px 0;
			font-size: 12px;
		}
	}

	@media (max-width: 700px) {
		.industry-hero {
			justify-content: flex-start;
			gap: 20px;
		}

		.hero-head {
			flex-direction: column;
			align-items: flex-start;
			gap: 14px;
		}

		.hero-action-row {
			justify-content: flex-start;
		}
	}

	/* 热门能力推荐弹窗 */
	.popup-mask {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: rgba(0, 0, 0, .65);
		z-index: 9998;
	}

	.ability-popup {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 920px;
		max-width: 90vw;
		max-height: 90vh;
		overflow-y: auto;
		padding: 26px;
		border: 1px solid #3b88e8;
		border-radius: 10px;
		background:
			linear-gradient(135deg, rgba(68, 193, 239, .14), transparent 22%) top left,
			linear-gradient(315deg, rgba(68, 193, 239, .1), transparent 22%) bottom right,
			rgba(12, 35, 85, .94);
		background-size: 100% 100%;
		box-shadow: inset 0 0 24px rgba(24, 132, 255, .18), 0 0 40px rgba(0, 14, 40, .6);
		z-index: 9999;
	}

	.ability-popup:before {
		content: '';
		position: absolute;
		top: -1px;
		left: -1px;
		width: 36px;
		height: 12px;
		border-top: 2px solid #44c1ef;
		border-left: 2px solid #44c1ef;
	}

	.popup-close {
		position: absolute;
		top: 10px;
		right: 16px;
		font-size: 30px;
		line-height: 1;
		cursor: pointer;
		color: #91c8ff;
		transition: color .2s;
	}

	.popup-close:hover {
		color: #fff;
	}

	.popup-title {
		margin-bottom: 24px;
		padding-left: 10px;
		font-size: 26px;
		font-weight: 400;
		color: #84d1ff;
		text-shadow: 0 0 10px rgba(73, 223, 255, .32);
		border-left: 3px solid #9bc74b;
	}

	.popup-card-row {
		display: flex;
		gap: 14px;
		margin-bottom: 26px;
	}

	.popup-stat-card {
		flex: 1;
		padding: 14px 8px;
		border: 1px solid rgba(68, 193, 239, .35);
		border-radius: 6px;
		background: rgba(24, 64, 134, .45);
		text-align: center;
		box-shadow: inset 0 0 12px rgba(24, 132, 255, .1);
	}

	.popup-stat-num {
		margin-bottom: 6px;
		font-family: DINPro, DIN, sans-serif;
		font-size: 30px;
		font-weight: bold;
		background: linear-gradient(180deg, #fff 15%, #f7ff57 100%);
		-webkit-background-clip: text;
		-webkit-text-fill-color: transparent;
	}

	.popup-stat-label {
		font-size: 15px;
		color: #b8d8ff;
	}

	.popup-chart-wrap {
		display: flex;
		gap: 20px;
		height: 280px;
		margin-bottom: 22px;
	}

	.popup-chart-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		border: 1px dashed #3572bc;
		border-radius: 6px;
		background: rgba(10, 40, 90, .3);
	}

	.popup-chart-label {
		flex: 0 0 auto;
		padding: 5px 10px;
		color: #74a9e0;
		font-size: 13px;
		text-align: center;
		border-bottom: 1px solid rgba(53, 114, 188, .3);
	}

	.popup-chart {
		flex: 1;
		min-height: 0;
		width: 100%;
	}

	.popup-price-panel {
		flex: 1;
		min-height: 0;
		overflow-y: auto;
		padding: 6px 10px;
	}

	.price-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 7px 8px;
		border-bottom: 1px solid rgba(53, 114, 188, .2);
	}

	.price-item:last-child {
		border-bottom: 0;
	}

	.price-name {
		color: #d8f1ff;
		font-size: 14px;
	}

	.price-change {
		font-family: DINPro, DIN, sans-serif;
		font-size: 15px;
		font-weight: 500;
	}

	.price-change.up {
		color: #ff5f5f;
	}

	.price-change.down {
		color: #9bc74b;
	}

	.popup-desc {
		color: #c2e0ff;
		font-size: 16px;
		line-height: 1.7;
	}

	@media (max-width: 700px) {
		.ability-popup {
			width: 94vw;
			padding: 18px;
		}

		.popup-title {
			font-size: 20px;
			margin-bottom: 16px;
		}

		.popup-card-row {
			flex-wrap: wrap;
			gap: 10px;
		}

		.popup-stat-card {
			flex: 1 1 calc(50% - 5px);
			padding: 10px 6px;
		}

		.popup-stat-num {
			font-size: 22px;
		}

		.popup-stat-label {
			font-size: 12px;
		}

		.popup-chart-wrap {
			flex-direction: column;
			height: auto;
			gap: 10px;
		}

		.popup-chart-box {
			height: 160px;
		}

		.popup-chart-label {
			font-size: 11px;
		}

		.popup-desc {
			font-size: 14px;
		}
	}
</style>
